import React, { memo, useState } from "react";
import { Card } from "./Card";
import { useTranslation } from "react-i18next";
import { Colors } from "../constants/Colors";
import { ArrowDown, ArrowUp } from "./Arrow";

const Recommendations = ({ rootCause, deviceName }) => {

  const { t, i18n } = useTranslation();
  const [visibleRecommendations, setVisibleRecommendations] = useState({});
  const loginType = localStorage.getItem("login_type");

  const [visibleSections, setVisibleSections] = useState({});

  const toggleSection = (item, section) => {
    setVisibleSections((prev) => ({
      ...prev,
      [item]: {
        ...prev[item],
        [section]: !prev[item]?.[section],
      },
    }));
  };

  const toggleRecommendation = (item) => {
    setVisibleRecommendations((prev) => ({
      ...prev,
      [item]: !prev[item],
    }));
  };

  const validTitles = [
    "latency",
    "packetLoss",
    "jitter",
    "cpu",
    "cpuUnderutilized",
    "storageUnderutilized",
    "memoryUnderutilized",
    "memory",
    "storage",
    "online",
    "dyingGasp",
    "los",
    "offline",
    "sync",
    "unknown",
    "suspend",
    "traffic",
    "deviceDown",
    "webapi",
    "cpuServer",
    "memoryServer",
    "storageServer",
    "cpuUnderutilizedServer",
    "memoryUnderutilizedServer",
    "storageUnderutilizedServer",



  ];

  const formatRecommendationTitle = (title, lang) => {
    if (lang === "id") {
      switch (title) {
        case "latency":
          return `${t("general.networkQuality")} - Latensi`;
        case "packetLoss":
          return `${t("general.networkQuality")} - Packet Loss`;
        case "jitter":
          return `${t("general.networkQuality")} - Jitter`;
        case "cpu":
          return "Perangkat - Kapasitas CPU Hampir Penuh";
        case "cpuUnderutilized":
          return "Perangkat - Penggunaan CPU Tidak Optimal";
        case "memory":
          return  "Perangkat - Kapasitas Memori Hampir Penuh";
        case "memoryUnderutilized":
          return "Perangkat - Penggunaan CPU Tidak Optimal";
        case "storage":
          return "Perangkat - Kapasitas Storage Hampir Penuh";
        case "storageUnderutilized":
          return "Perangkat - Penggunaan Storage Tidak Optimal";
        case "traffic":
          return "Jaringan - Trafik Tinggi";
        case "cpuServer":
          return "Server - Kapasitas CPU Hampir Penuh";
        case "memoryServer":
          return "Server - Kapasitas Memori Hampir Penuh";
        case "storageServer":
          return "Server - Kapasitas Storage Hampir Penuh";
        case "cpuUnderutilizedServer":
          return "Server - Penggunaan CPU Tidak Optimal";
        case "memoryUnderutilizedServer":
          return "Server - Penggunaan Memori Tidak Optimal";
        case "storageUnderutilizedServer":
          return "Server - Penggunaan Storage Tidak Optimal";
        case "processCPU":
          return "Server - Process - Kapasitas CPU Hampir Penuh";
        case "processMemory":
          return "Server - Process - Kapasitas Memori Hampir Penuh";
        case "containerCPU":
          return "Server - Container - Kapasitas CPU Hampir Penuh";
        case "containerMemory":
          return "Server - Container - Kapasitas Memori Hampir Penuh";
        case "webapi":
          return "Web API - Response Time Tinggi";
        case "deviceDown":
          return "Perangkat Mati / Jaringan ISP Mati";
        case "online":
          return "Internet Online";
        case "dyingGasp":
          return "Internet Dying Gasp";
        case "los":
          return "Loss of Signal (LOS)";
        case "offline":
          return "Internet Offline";
        case "sync":
          return "Internet Sync";
        case "unknown":
          return "Internet Unknown";
        case "suspend":
          return "Internet Suspend";
        default:
          return title;
      }

    } else {
    switch (title) {
      case "latency":
        return `${t("general.networkQuality")} - Latency`;
      case "packetLoss":
        return `${t("general.networkQuality")} - Packet Loss`;
      case "jitter":
        return `${t("general.networkQuality")} - Jitter`;
      case "cpu":
        return `Device - CPU Capacity is Almost Full`;
      case "cpuUnderutilized":
        return `Device - CPU Capacity is Underutilized`;
      case "memory":
        return `Device - Memory Capacity is Almost Full`;
      case "memoryUnderutilized":
        return `Device - Memory Capacity is Underutilized`;
      case "storage":
        return `Device - Storage Capacity is Almost Full`;
      case "storageUnderutilized":
        return `Device - Storage Capacity is Underutilized`;
      case "traffic":
        return `Network - High Traffic`;
      case "cpuServer":
        return `Server - CPU Capacity is Almost Full`;
      case "memoryServer":
        return `Server - Memory Capacity is Almost Full`;
      case "storageServer":
        return `Server - Storage Capacity is Almost Full`;
      case "cpuUnderutilizedServer":
        return `Server - CPU Capacity is Underutilized`;
      case "memoryUnderutilizedServer":
        return `Server - Memory Capacity is Underutilized`;
      case "storageUnderutilizedServer":
        return `Server - Storage Capacity is Underutilized`;
      case "processCPU":
        return `Server - Process - CPU Capacity is Almost Full`;
      case "processMemory":
        return `Server - Process - Memory Capacity is Almost Full`;
      case "containerCPU":
        return `Server - Container - CPU Capacity is Almost Full`;
      case "containerMemory":
        return `Server - Container - Memory Capacity is Almost Full`;
      case "webapi":
        return `Web API - High Response Time`;
      case "deviceDown":
        return "Device Power OFF / Network ISP DOWN";
      case "online":
        return "Internet Online";
      case "dyingGasp":
        return "Internet Dying Gasp";
      case "los":
        return "Loss of Signal (LOS)";
      case "offline":
        return "Internet Offline";
      case "sync":
        return "Internet Sync";
      case "unknown":
        return "Internet Unknown";
      case "suspend":
        return "Internet Suspend";
      
      default:
        return title;
    }
    }
  };



  const tagsStyles = {
    color: "black",
    fontSize: "14px",
    lineHeight: "20px",
    textAlign: "justify",
    listStyleType: "disc",
  };

  const recommendations = {
    latency: {
      title: "Latency",
      definition: (
        <div>
          <p>Latency adalah waktu yang dibutuhkan data untuk menempuh jarak dari asal ke tujuan.Misalnya, dari perangkat
            pengguna (seperti laptop) ke router atau dari router ke server. Secara
            lebih spesifik, latency mencakup seluruh jeda atau keterlambatan yang
            terjadi.
          </p>
        </div>
      ),
      analysis: (
        <div>
          <p> Dampak umum:</p>
          <ul style={{ listStyleType: "disc", paddingLeft: "20px" }}>
            <li><strong>Penurunan Kualitas Layanan:</strong> Latency tinggi menyebabkan komunikasi terputus-putus, delay, atau respons lambat.</li>
          </ul>
          <br />
          <p>Dampak pada komponen lain: </p>
          <ul style={{ listStyleType: "disc", paddingLeft: "20px" }}>
            <li><strong>Device Capacity:</strong> Latency tinggi memperburuk performa perangkat, membuat layanan menjadi lambat.</li>
            <li><strong>Traffic:</strong> Memperlambat pengiriman data, meningkatkan kemacetan jaringan, dan menurunkan efisiensi transfer.</li>
          </ul>
        </div>
      ),
      solution: (
        <div>
          <p>
            Lakukan rekomendasi langkah-langkah ini untuk mengatasi permasalahan
            Latency pada jaringan Anda:
          </p>
          <ol style={{ listStyleType: "decimal", paddingLeft: "20px" }}>
            <li>
              <strong>Optimasi Perangkat Router dan Firmware</strong>
              <ul style={{ listStyleType: "disc", paddingLeft: "20px" }}>
                <li>
                  Restart router untuk melepaskan memori yang digunakan dan
                  memperbaiki kinerja perangkat.
                </li>
                <li>
                  Jadwalkan restart otomatis jika router mendukung fitur tersebut.
                </li>
                <li>
                  Pastikan router selalu menggunakan firmware terbaru untuk
                  memperbaiki bug dan meningkatkan performa.
                </li>
                <li>
                  Kunjungi situs resmi produsen router untuk mengunduh versi
                  terbaru.
                </li>
                <li>
                  Jika konfigurasi yang ada sudah terlalu kompleks atau
                  bermasalah, lakukan reset pabrik dan konfigurasi ulang dari
                  awal.
                </li>
                <li>
                  Hindari konfigurasi yang tidak diperlukan untuk mengurangi beban
                  router.
                </li>
              </ul>
              <div></div>
            </li>
            <li>
              <strong>Optimasi Jaringan Nirkabel (Wi-Fi)</strong>
              <ul style={{ listStyleType: "disc", paddingLeft: "20px" }}>
                <li>
                  Gunakan frekuensi 5 GHz untuk mengurangi interferensi dan
                  mendapatkan performa lebih baik (untuk perangkat yang
                  mendukung).
                </li>
                <li>
                  Gunakan Wi-Fi Analyzer untuk mencari channel yang kurang padat
                  dan menghindari interferensi dari jaringan tetangga.
                </li>
                <li>
                  Kurangi jarak antara perangkat dan router untuk mendapatkan
                  sinyal lebih kuat dan latency lebih rendah.
                </li>
                <li>
                  Hindari penghalang fisik seperti dinding tebal atau logam yang
                  dapat menghambat sinyal.
                </li>
                <li>
                  Gunakan Wi-Fi extender atau mesh network jika area cakupan
                  terlalu luas, untuk mengurangi latency dan memperkuat sinyal di
                  semua area.
                </li>
              </ul>
              <div></div>
            </li>
            <li>
              <strong>Manajemen Trafik dan Kualitas Layanan (QoS)</strong>
              <ul style={{ listStyleType: "disc", paddingLeft: "20px" }}>
                <li>
                  Konfigurasikan QoS pada router untuk memprioritaskan trafik
                  penting, seperti VoIP, video conference, dan game online.
                </li>
                <li>
                  Setel prioritas untuk aplikasi atau perangkat tertentu yang
                  sering digunakan.
                </li>
                <li>
                  Putus koneksi perangkat yang tidak digunakan untuk mengurangi
                  beban router.
                </li>
                <li>
                  Atur jaringan tamu (guest network) agar tidak mengganggu
                  jaringan utama.
                </li>
              </ul>
              <div></div>
            </li>
            <li>
              <strong>Ganti atau Tingkatkan Router</strong>
              <ul style={{ listStyleType: "disc", paddingLeft: "20px" }}>
                <li>
                  Jika router sudah berusia tua / sering mengalami overload,
                  pertimbangkan untuk upgrade ke model yang baru dengan fitur:
                </li>
                <li>WI-Fi 6 atau Wi-Fi 6E untuk performa lebih baik.</li>
                <li>Dual-band atau Tri-band untuk mendistribusikan trafik.</li>
                <li>
                  CPU dan RAM lebih tinggi agar router dapat menangani banyak
                  perangkat tanpa latency.
                </li>
              </ul>
              <div></div>
            </li>
            <li>
              <strong>Periksa Kabel dan Koneksi Fisik</strong>
              <ul style={{ listStyleType: "disc", paddingLeft: "20px" }}>
                <li>
                  Gunakan kabel Ethernet Cat6 atau Cat7 untuk memastikan transfer
                  data lebih cepat dan stabil.
                </li>
                <li>
                  Periksa kabel untuk melihat apakah ada kerusakan atau koneksi
                  yang longgar.
                </li>
                <li>
                  Pastikan tidak ada looping (siklus) dalam jaringan yang dapat
                  menyebabkan peningkatan trafik dan latency.
                </li>
                <li>
                  Gunakan Spanning Tree Protocol (STP) jika ada beberapa switch
                  dalam jaringan.
                </li>
              </ul>
              <div></div>
            </li>
            <li>
              <strong>Monitoring dan Diagnostik</strong>
              <ul style={{ listStyleType: "disc", paddingLeft: "20px" }}>
                <li>
                  Gunakan layanan Network Monitoring untuk memantau performa
                  router dan perangkat secara real-time.
                </li>
                <li>
                  Identifikasi perangkat atau aplikasi yang memakan bandwidth
                  berlebih dan menyebabkan latency.
                </li>
                <li>
                  Jalankan ping ke gateway ISP atau server luar untuk memastikan
                  masalah bukan dari ISP.
                </li>
                <li>
                  Hubungi ISP jika latency tinggi disebabkan oleh jaringan
                  eksternal.
                </li>
              </ul>
              <div></div>
            </li>
            <li>
              <strong>Implementasi Load Balancing atau Backup Link</strong>
              <ul style={{ listStyleType: "disc", paddingLeft: "20px" }}>
                <li>
                  Load balancer dapat membantu mendistribusikan beban jika ada
                  banyak perangkat dalam jaringan.
                </li>
                <li>
                  Gunakan link backup jika terjadi overload atau masalah dengan
                  jalur koneksi utama.
                </li>
              </ul>
            </li>
          </ol>
        </div>
      )
    },
    packetLoss: {
      title: "Packet Loss",
      definition: (
        <div>
          <p>Packet Loss adalah kondisi hilangnya data pada saat pengiriman dilakukan sehingga data tidak diterima seutuhnya di tempat tujuan.</p>
        </div>
      ),
      analysis: (
        <div>
          <p> Dampak umum:</p>
          <ul style={{ listStyleType: "disc", paddingLeft: "20px" }}>
            <li><strong>Penurunan Kualitas Layanan:</strong> Mengakibatkan suara terputus-putus dan video buram atau terhenti.</li>
            <li><strong>Kinerja Data:</strong> Kehilangan data dapat menyebabkan gangguan pada aplikasi real-time dan penurunan pengalaman pengguna.</li>
          </ul>
          <br />
          <p>Dampak pada komponen lain: </p>
          <ul style={{ listStyleType: "disc", paddingLeft: "20px" }}>
            <li><strong>Device Capacity:</strong> Perangkat menjadi tidak stabil, menyebabkan kinerja menurun dan aplikasi atau layanan tidak optimal.</li>
            <li><strong>Traffic:</strong> Packet loss meningkatkan kemacetan dan memperlambat pengiriman data, mengurangi efisiensi jaringan.</li>
          </ul>
        </div>
      ),
      solution: (
        <div>
          <p>
            Packet loss adalah kegagalan pengiriman paket data di jaringan, di
            mana paket tidak sampai ke tujuan atau hilang selama transmisi. Dalam
            jaringan, data dikirim dalam bentuk paket-paket kecil, dan ketika ada
            gangguan, kemacetan, atau kerusakan perangkat, beberapa paket bisa
            hilang. Ini menyebabkan koneksi tidak optimal dan memengaruhi performa
            berbagai aplikasi, terutama yang membutuhkan komunikasi real-time.
          </p>
          <p>
            Lakukan rekomendasi langkah-langkah ini untuk mengatasi permasalahan
            Packet Loss pada jaringan Anda:
          </p>
          <ol style={{ listStyleType: "decimal", paddingLeft: "20px" }}>
            <li>
              <strong>Kurangi Beban Jaringan: </strong>
              Batasi jumlah perangkat aktif dan hentikan aplikasi penggunaan
              bandwidth besar seperti unduhan atau streaming saat tidak
              diperlukan.
            </li>
            <li>
              <strong>Gunakan Koneksi Kabel (Ethernet): </strong>
              Ethernet lebih stabil dibandingkan Wi-Fi dan mengurangi risiko
              interferensi.
            </li>
            <li>
              <strong>Ganti atau Perbaiki Kabel Jaringan: </strong>
              Gunakan kabel berkualitas tinggi seperti Cat6 atau Cat7, dan periksa
              apakah ada kabel yang longgar atau rusak.
            </li>
            <li>
              <strong>Update Firmware dan Perangkat Keras: </strong>
              Perbarui firmware router atau switch untuk memperbaiki bug dan
              meningkatkan performa.
            </li>
            <li>
              <strong>Aktifkan QoS (Quality of Service): </strong>
              QoS dapat memprioritaskan trafik penting (seperti VoIP dan video
              call) dan mencegah packet loss saat jaringan padat.
            </li>
            <li>
              <strong>Minimalkan Interferensi Wi-Fi: </strong>
              Pindah ke frekuensi 5 GHz untuk mengurangi gangguan dan pilih kanal
              yang tidak padat.
            </li>
            <li>
              <strong>Hubungi ISP: </strong>
              Jika packet loss terjadi di luar jaringan lokal, laporkan ke ISP
              untuk perbaikan atau pemecahan masalah.
            </li>
          </ol>
        </div>
      )
    },
    jitter: {
      title: "Jitter",
      definition: (
        <div>
          <p>
            Jitter adalah kumpulan dari semua delay yang terjadi selama proses data dikirimkan sampai dengan data diterima.
          </p>
        </div>
      ),
      analysis: (
        <div>
          <p> Dampak umum:</p>
          <ul style={{ listStyleType: "disc", paddingLeft: "20px" }}>
            <li><strong>Penurunan Kualitas Layanan:</strong>
              <ol style={{ listStyleType: "circle", paddingLeft: "20px" }}>
                <li><strong>Panggilan suara:</strong> Suara menjadi terputus-putus atau tidak jelas.</li>
                <li><strong>Video Conference:</strong> Video tidak sinkron dengan audio atau terputus-putus.</li>
              </ol>
            </li>
            <li><strong>Gangguan Stabilitas Koneksi:</strong> Jaringan menjadi tidak stabil, memperburuk pengalaman pengguna, terutama pada aplikasi yang membutuhkan transfer data secara konsisten.</li>
          </ul>
          <br />
          <p>Dampak pada komponen lain: </p>
          <ul style={{ listStyleType: "disc", paddingLeft: "20px" }}>
            <li><strong>Device Capacity:</strong> Perangkat bekerja lebih keras akibat data terlambat atau hilang, menurunkan kinerja.</li>
            <li><strong>Traffic:</strong> Jitter tinggi dapat memperburuk kemacetan jaringan, meningkatkan latency, dan mengurangi kecepatan transfer data, terutama pada lalu lintas padat.</li>

          </ul>
        </div>
      ),
      solution: (
        <div>
          <p>
            Lakukan rekomendasi langkah-langkah ini untuk mengatasi permasalahan
            Jitter pada jaringan Anda:
          </p>
          <ol style={{ listStyleType: "decimal", paddingLeft: "20px" }}>
            <li>
              <strong>Aktifkan QoS (Quality of Service): </strong>
              Konfigurasi QoS pada router untuk memprioritaskan aplikasi real-time
              seperti VoIP dan video conference, agar paket penting tidak
              tertunda.
            </li>
            <li>
              <strong>Kurangi Beban Jaringan: </strong>
              Batasi jumlah perangkat yang terhubung atau hentikan aplikasi yang
              menggunakan bandwidth besar, seperti unduhan besar atau streaming
              video.
            </li>
            <li>
              <strong>Gunakan Koneksi Kabel Ethernet: </strong>
              Kabel Ethernet lebih stabil dan memiliki latency serta jitter lebih
              rendah dibandingkan Wi-Fi.
            </li>
            <li>
              <strong>Optimalkan Router dan Switch: </strong>
              Gunakan router atau switch dengan performa tinggi dan pastikan
              firmware selalu diperbarui untuk meningkatkan efisiensi pemrosesan
              paket.
            </li>
            <li>
              <strong>Minimalkan Interferensi Wi-Fi: </strong>
              Pindah ke frekuensi 5 GHz dan pilih saluran Wi-Fi yang tidak terlalu
              padat untuk menghindari interferensi.
            </li>
            <li>
              <strong>Monitoring dan Diagnostik Jaringan: </strong>
              Pantau jaringan secara rutin menggunakan alat seperti PRTG Network
              Monitor untuk mendeteksi jitter dan memperbaikinya sebelum berdampak
              signifikan.
            </li>
          </ol>
        </div>
      )
    },
    cpu: {
      title: "CPU",
      definition: (
        <div>
          <ul style={{ listStyleType: "disc", paddingLeft: "20px" }}>
            <li> CPU (Central Processing Unit) adalah komponen utama yang menjalankan instruksi dan proses untuk mengoperasikan perangkat jaringan seperti router, switch, atau server.</li>
            <li> CPU hampir penuh  terjadi ketika berada dalam status warning (penggunaan{' >'} 50%) dan status critical (penggunaan {'>'} 80%), yang menunjukkan bahwa perangkat hampir mencapai batas kapasitasnya, sehingga kinerja perangkat dapat terganggu atau terhambat.</li>
          </ul>
        </div>
      ),
      analysis: (
        <div>
          <p>Jika kapasitas CPU hampir penuh:</p>

          <ul style={{ listStyleType: "disc", paddingLeft: "20px" }}>
            <li><strong>Kinerja Menurun:</strong> Perangkat menjadi lambat karena CPU sulit memproses data.</li>
            <li><strong>Gangguan Layanan:</strong> Operasional jaringan terganggu, menyebabkan keterlambatan atau downtime.</li>
            <li><strong>Potensi Crash:</strong> Beban tinggi dapat membuat perangkat gagal beroperasi.</li>
            <li><strong>Efek Sistem:</strong> Perangkat lain dalam jaringan terkena dampak, memperburuk kinerja keseluruhan.</li>
          </ul>

          <br />

          <p>
            Dampak pada komponen lain:
          </p>
          <ul style={{ listStyleType: "disc", paddingLeft: "20px" }}>
            <li><strong>Quality of Service (QoS):</strong> Penurunan kinerja CPU memengaruhi kualitas layanan jaringan.</li>
            <li><strong>Traffic:</strong> Pemrosesan data terhambat, menyebabkan latensi tinggi dan kehilangan data.</li>
          </ul>
        </div>
      ),
      solution: (
        <div>
          <p>
            Lakukan langkah-langkah ini untuk mengatasi masalah CPU Perangkat:
          </p>
          <ol style={{ listStyleType: "decimal", paddingLeft: "20px" }}>
            <li>Redistribusikan beban kerja ke node lain yang kurang sibuk.</li>
            <li>
              Optimalkan aplikasi yang berjalan untuk mengurangi penggunaan CPU.
            </li>
            <li>
              Tingkatkan kapasitas CPU dengan menambahkan prosesor atau core
              tambahan.
            </li>
            <li>
              Nonaktifkan atau hentikan aplikasi yang tidak penting atau
              berlebihan.
            </li>
            <li>
              Gunakan load balancer untuk mengelola dan mendistribusikan lalu
              lintas secara lebih efisien.
            </li>
          </ol>
        </div>
      )
    },
    cpuUnderutilized: {
      title: "CPU Underutilized",
      definition: (
        <div>
          <ul style={{ listStyleType: "disc", paddingLeft: "20px" }}>
            <li>CPU (Central Processing Unit) adalah komponen utama yang menjalankan instruksi dan proses untuk mengoperasikan perangkat jaringan seperti router, switch, atau server.</li>
            <li>CPU Underutilization terjadi ketika penggunaan CPU {"<"} 30%, menunjukkan perangkat tidak dimanfaatkan secara optimal, sehingga banyak kapasitas yang terbuang.</li>
          </ul>
        </div>
      ),
      analysis: (
        <div>
          <p> Jika CPU underutilized:</p>
          <ul style={{ listStyleType: "disc", paddingLeft: "20px" }}>
            <li><strong>Efisiensi Rendah:</strong> Kapasitas perangkat terbuang sia-sia.</li>
            <li><strong>Konsumsi Daya Berlebihan:</strong> Perangkat tetap aktif tetapi tidak memberikan performa optimal.</li>
            <li><strong>Biaya Operasional Tinggi:</strong> Penggunaan perangkat tidak sesuai dengan potensi sebenarnya.</li>
          </ul>
          <br />
          <p>
            Dampak pada komponen lain:
          </p>
          <ul style={{ listStyleType: "disc", paddingLeft: "20px" }}>
            <li><strong>Quality of Service (QoS):</strong> Layanan jaringan tidak dimaksimalkan karena perangkat tidak bekerja optimal.</li>
            <li><strong>Traffic:</strong> Aliran data dapat terhambat karena pengelolaan sumber daya tidak efisien.</li>
          </ul>
        </div>
      ),
      solution: (
        <div>

          <p>
            Berikut adalah langkah-langkah yang bisa Anda lakukan untuk mengatasi
            CPU yang underutilized atau underload:
          </p>
          <ol style={{ listStyleType: "decimal", paddingLeft: "20px" }}>
            <li>
              <strong>Lalu Lintas Jaringan Rendah</strong>
              <ul style={{ listStyleType: "disc", paddingLeft: "20px" }}>
                <li>
                  Jika lalu lintas jaringan tidak terlalu tinggi, CPU router
                  mungkin tidak perlu bekerja keras. Biasanya, ini terjadi pada
                  jam-jam sepi atau ketika jaringan tidak banyak digunakan.
                </li>
                <li>
                  Solusi: Coba lakukan pemantauan saat lalu lintas jaringan sedang
                  tinggi, atau gunakan alat simulasi lalu lintas untuk menguji
                  performa pada beban lebih tinggi.
                </li>
              </ul>
              <div></div>
            </li>
            <li>
              <strong>
                Spesifikasi Router yang Terlalu Tinggi untuk Kebutuhan
              </strong>
              <ul style={{ listStyleType: "disc", paddingLeft: "20px" }}>
                <li>
                  CPU router yang terlalu kuat untuk kebutuhan jaringan saat ini
                  bisa menyebabkan underutilized, terutama jika hanya digunakan
                  untuk routing dasar tanpa fitur tambahan.
                </li>
                <li>
                  Solusi: Pastikan bahwa spesifikasi router sesuai dengan
                  kebutuhan jaringan. Jika router mendukung fitur-fitur tambahan
                  seperti firewall atau VPN, pertimbangkan untuk mengaktifkan
                  fitur tersebut guna meningkatkan pemanfaatan CPU.
                </li>
              </ul>
              <div></div>
            </li>
            <li>
              <strong>Konfigurasi yang Kurang Optimal</strong>
              <ul style={{ listStyleType: "disc", paddingLeft: "20px" }}>
                <li>
                  Beberapa konfigurasi bisa menyebabkan lalu lintas tidak
                  terdistribusi secara merata ke semua core CPU yang tersedia,
                  sehingga membuat pemanfaatan CPU rendah.
                </li>
                <li>
                  Solusi: Cek konfigurasi load balancing atau distribusi beban,
                  terutama jika router memiliki multi-core CPU. Pastikan bahwa
                  tugas-tugas berat seperti NAT atau VPN dapat didistribusikan
                  dengan baik ke semua core.
                </li>
              </ul>
              <div></div>
            </li>
            <li>
              <strong>Adanya Bottleneck pada Komponen Lain</strong>
              <ul style={{ listStyleType: "disc", paddingLeft: "20px" }}>
                <li>
                  Underutilized bisa juga terjadi jika ada bottleneck atau
                  hambatan pada komponen lain seperti memori atau port jaringan ,
                  yang membatasi performa keseluruhan meskipun CPU tidak
                  terbebani.
                </li>
                <li>
                  Solusi: Periksa penggunaan memori dan kapasitas port jaringan
                  untuk memastikan tidak ada yang menjadi hambatan. Jika perlu,
                  lakukan upgrade atau sesuaikan setting agar semua komponen dapat
                  bekerja secara optimal.
                </li>
              </ul>
              <div></div>
            </li>
            <li>
              <strong>Optimalkan Penggunaan Fitur Router</strong>
              <ul style={{ listStyleType: "disc", paddingLeft: "20px" }}>
                <li>
                  Jika router memiliki kemampuan fitur tambahan (seperti IDS/IPS,
                  firewall tingkat lanjut, QoS), mengaktifkan fitur ini dapat
                  meningkatkan pemanfaatan CPU.
                </li>
                <li>
                  Solusi: Aktifkan fitur-fitur tambahan sesuai kebutuhan jaringan,
                  misalnya dengan mengaktifkan inspeksi paket, kontrol lalu
                  lintas, atau fitur keamanan untuk memaksimalkan penggunaan
                  router.
                </li>
              </ul>
              <div></div>
            </li>
          </ol>
        </div>
      )
    },
    memory: {
      title: "Memory",
      definition: (
        <div>
          <ul style={{ listStyleType: "disc", paddingLeft: "20px" }}>
            <li>RAM (Random Access Memory) adalah memori sementara yang digunakan perangkat jaringan untuk menyimpan dan mengakses data secara cepat.</li>
            <li>RAM hampir penuh terjadi ketika berada dalam status warning (penggunaan {'>'} 50%) dan status critical (penggunaan {'>'} 80%), yang menunjukkan bahwa perangkat hampir mencapai batas kapasitasnya, sehingga kinerja perangkat dapat terganggu atau terhambat.</li>
          </ul>
        </div>),
      analysis: (
        <div>
          <p>Jika kapasitas Memory hampir penuh:</p>
          <ul style={{ listStyleType: "disc", paddingLeft: "20px" }}>
            <li><strong>Kinerja Menurun:</strong> Proses data menjadi lebih lambat, memengaruhi respons perangkat.</li>
            <li><strong>Gangguan Layanan:</strong> Layanan jaringan terhambat, menyebabkan keterlambatan atau downtime.</li>
            <li><strong>Risiko Crash:</strong> Kelebihan memori dapat membuat perangkat tidak stabil atau gagal beroperasi.</li>
            <li><strong>Efek Sistemik:</strong> Perangkat lain dalam jaringan ikut terdampak, memperburuk kinerja keseluruhan.</li>
          </ul>
          <br />
          <p>Dampak pada komponen lain: </p>
          <ul style={{ listStyleType: "disc", paddingLeft: "20px" }}>
            <li><strong>Quality of Service (QoS):</strong> Penurunan performa memori memengaruhi kualitas layanan jaringan.</li>
            <li><strong>Traffic:</strong> Pemrosesan data terhambat, meningkatkan latensi atau kehilangan paket.</li>
          </ul>
        </div>
      ),
      solution: (
        <div>
          <p>
            Lakukan langkah-langkah ini untuk mengatasi masalah Memory Perangkat:
          </p>
          <ol style={{ listStyleType: "decimal", paddingLeft: "20px" }}>
            <li> Tingkatkan kapasitas Memory pada node yang terkena dampak.</li>
            <li>
              Identifikasi dan optimalkan aplikasi yang menggunakan banyak Memory.
            </li>
            <li>Hentikan aplikasi yang tidak perlu untuk membebaskan Memory.</li>
            <li>
              Gunakan teknik paging atau swap yang lebih efisien jika
              memungkinkan.
            </li>
            <li>
              Distribusikan aplikasi ke node lain dengan Memory yang lebih rendah
              penggunaannya.
            </li>
          </ol>
        </div>
      )
    },
    memoryUnderutilized: {
      title: "Memory Underutilized",
      definition: (
        <div>
          <ul style={{ listStyleType: "disc", paddingLeft: "20px" }}>
            <li>RAM (Random Access Memory) adalah memori sementara yang digunakan perangkat jaringan untuk menyimpan dan mengakses data secara cepat.</li>
            <li>RAM Underutilization terjadi ketika penggunaan memory {"<"} 30%, menunjukkan perangkat tidak dimanfaatkan secara optimal, sehingga banyak kapasitas yang terbuang.</li>
          </ul>
        </div>
      ),
      analysis: (
        <div>
          <p> Jika kapasitas Memory underutilized:</p>
          <ul style={{ listStyleType: "disc", paddingLeft: "20px" }}>
            <li><strong>Efisiensi Rendah:</strong> Kapasitas perangkat tidak dimanfaatkan secara optimal.</li>
            <li><strong>Konsumsi Daya Tidak Efisien:</strong> Perangkat tetap aktif meski sumber daya tidak digunakan secara efektif.</li>
            <li><strong>Biaya Operasional Tinggi:</strong> Penggunaan perangkat tidak sesuai dengan kebutuhan aktual.</li>
          </ul>
          <br />
          <p>
            Dampak pada komponen lain:</p>
          <ul style={{ listStyleType: "disc", paddingLeft: "20px" }}>
            <li><strong>Quality of Service (QoS):</strong> Layanan jaringan tidak dimaksimalkan karena memori tidak bekerja optimal.</li>
            <li><strong>Traffic:</strong> Pemrosesan data berjalan lambat karena pengelolaan sumber daya tidak efisien.</li>
          </ul>
        </div>

      ),
      solution: (
        <div>
          <p>
            Berikut adalah langkah-langkah yang bisa Anda lakukan untuk mengatasi
            RAM yang underutilized atau underload:
          </p>
          <ol style={{ listStyleType: "decimal", paddingLeft: "20px" }}>
            <li>
              <strong>⁠Perangkat Tidak Dikonfigurasi untuk Beban Maksimum</strong>
              <ul style={{ listStyleType: "disc", paddingLeft: "20px" }}>
                <li>
                  Jika perangkat hanya menjalankan fungsi dasar (seperti routing
                  atau NAT sederhana) tanpa fitur tambahan seperti firewall, QoS,
                  atau VPN. RAM mungkin tidak digunakan secara optimal.
                </li>
                <li>
                  Solusi: Aktifkan fitur tambahan yang relevan, seperti inspeksi
                  paket (DPI), Quality of Service (QoS), atau log traffic .
                  Sesuaikan konfigurasi untuk memanfaatkan fitur yang mendukung
                  stabilitas dan keamanan jaringan.
                </li>
              </ul>
              <div></div>
            </li>
            <li>
              <strong>⁠Spesifikasi Perangkat Berlebihan untuk Kebutuhan</strong>
              <ul style={{ listStyleType: "disc", paddingLeft: "20px" }}>
                <li>
                  Router dengan RAM besar mungkin dirancang untuk menangani beban
                  jaringan yang jauh lebih tinggi daripada yang Anda miliki saat
                  ini.
                </li>
                <li>
                  Solusi: Evaluasi kebutuhan jaringan. Jika kebutuhan jaringan
                  Anda kecil, mungkin cukup menggunakan perangkat dengan
                  spesifikasi yang lebih rendah. Namun, jika ada rencana untuk
                  ekspansi jaringan, tidak perlu dilakukan tindakan khusus, karena
                  ekstra RAM akan bermanfaat di masa depan.
                </li>
              </ul>
              <div></div>
            </li>
            <li>
              <strong>⁠Traffic Jaringan Ringan</strong>
              <ul style={{ listStyleType: "disc", paddingLeft: "20px" }}>
                <li>
                  Jika jaringan Anda tidak terlalu sibuk atau tidak banyak
                  perangkat terhubung, perangkat mungkin tidak dapat memanfaatkan
                  RAM secara maksimal.
                </li>
                <li>
                  Solusi: Uji performa perangkat pada beban traffic yang lebih
                  tinggi. Simulasikan traffic menggunakan alat seperti iPerf atau
                  trafgen untuk melihat bagaimana memori digunakan dalam kondisi
                  berat.
                </li>
              </ul>
              <div></div>
            </li>
            <li>
              <strong>⁠Cache Tidak Dimanfaatkan Secara Optimal</strong>
              <ul style={{ listStyleType: "disc", paddingLeft: "20px" }}>
                <li>
                  RAM perangkat sering digunakan untuk caching (seperti ARP cache,
                  DNS cache, atau buffering). Jika cache kecil, RAM tidak terpakai
                  optimal.
                </li>
                <li>
                  Solusi: Perbesar ukuran cache DNS, ARP, atau buffer paket jika
                  perangkat mendukung pengaturan tersebut. Jika Anda menggunakan
                  fitur seperti Content Filtering atau Proxy, sesuaikan agar
                  memori dapat digunakan lebih baik.
                </li>
              </ul>
              <div></div>
            </li>
            <li>
              <strong>Tidak Ada Fitur Log yang Aktif</strong>
              <ul style={{ listStyleType: "disc", paddingLeft: "20px" }}>
                <li>
                  Logging aktivitas jaringan menggunakan RAM. Jika logging
                  dimatikan, RAM akan tetap kosong.
                </li>
                <li>
                  Solusi: Aktifkan logging lalu lintas untuk tujuan monitoring
                  atau analisis. Pastikan penggunaan logging tidak membebani
                  performa secara berlebihan.
                </li>
              </ul>
              <div></div>
            </li>
            <li>
              <strong>⁠Potensi Bottleneck pada Komponen Lain</strong>
              <ul style={{ listStyleType: "disc", paddingLeft: "20px" }}>
                <li>
                  Jika komponen lain seperti CPU atau port jaringan menjadi
                  bottleneck, router tidak dapat memanfaatkan RAM secara maksimal.
                </li>
                <li>
                  Solusi: Analisis performa perangkat secara keseluruhan. Jika CPU
                  atau bandwidth port terlalu rendah, pertimbangkan upgrade router
                  atau optimasi konfigurasi.
                </li>
              </ul>
              <div></div>
            </li>
          </ol>
        </div>
      )
    },
    storage: {
      title: "Storage",
      definition: (
        <div>
          <ul style={{ listStyleType: "disc", paddingLeft: "20px" }}>
            <li>Storage (Penyimpanan) adalah kapasitas untuk menyimpan data pada perangkat jaringan, seperti HDD atau SSD, yang menyimpan data, konfigurasi, dan log penting untuk operasi perangkat.</li>
            <li>Storage hampir penuh terjadi ketika berada dalam status warning (penggunaan {'>'} 50%) dan status critical (penggunaan {'>'} 80%), yang menunjukkan bahwa perangkat hampir mencapai batas kapasitasnya, sehingga kinerja perangkat dapat terganggu atau terhambat.</li>

          </ul>
        </div>
      ),
      analysis: (
        <div>
          <p> Jika kapasitas storage hampir penuh:</p>
          <ul style={{ listStyleType: "disc", paddingLeft: "20px" }}>
            <li><strong>Penurunan Kinerja:</strong> Penyimpanan penuh dapat memperlambat pemrosesan data.</li>
            <li><strong>Gangguan Operasional:</strong> Data baru tidak dapat disimpan, menyebabkan kegagalan sistem atau aplikasi.</li>
            <li><strong>Potensi Kehilangan Data:</strong> Risiko kehilangan data penting meningkat karena penyimpanan tidak mencukupi.</li>
          </ul>
          <ul style={{ listStyleType: "disc", paddingLeft: "20px" }}>
            <li><strong>Quality of Service (QoS):</strong> Kinerja jaringan menurun karena pemrosesan data terhambat.</li>
            <li><strong>Traffic:</strong> Latensi meningkat, dan kehilangan paket dapat terjadi akibat keterbatasan kapasitas penyimpanan.</li>
          </ul>
        </div>
      ),
      solution: (
        <div>
          <p>
            Lakukan langkah-langkah ini untuk mengatasi masalah Storage Perangkat:
          </p>
          <ol style={{ listStyleType: "decimal", paddingLeft: "20px" }}>
            <li>
              {" "}
              Hapus atau arsipkan data yang tidak diperlukan untuk mengosongkan
              ruang storage.
            </li>
            <li>
              Optimalkan penggunaan storage dengan mengompresi data jika
              memungkinkan.
            </li>
            <li>
              Pindahkan data yang jarang diakses ke penyimpanan yang lebih lambat
              atau murah.
            </li>
            <li>
              Tingkatkan kapasitas storage dengan menambahkan drive baru atau
              meningkatkan kapasitas drive yang ada.
            </li>
            <li>
              Implementasikan kebijakan retensi data yang lebih ketat untuk
              membatasi jumlah data yang disimpan.
            </li>
          </ol>
        </div>
      )
    },
    storageUnderutilized: {
      title: "Storage Underutilized",
      definition: (
        <div>
          <ul style={{ listStyleType: "disc", paddingLeft: "20px" }}>
            <li>Storage (Penyimpanan) adalah kapasitas untuk menyimpan data pada perangkat jaringan, seperti HDD atau SSD, yang menyimpan data, konfigurasi, dan log penting untuk operasi perangkat.</li>
            <li>Storage Underutilization terjadi ketika penggunaan storage {'<'} 30%, menunjukkan perangkat tidak dimanfaatkan secara optimal, sehingga banyak kapasitas yang terbuang.</li>
          </ul>
        </div>
      ),
      analysis: (
        <div>
          <p>Jika storage underutilized:</p>
          <ul style={{ listStyleType: "disc", paddingLeft: "20px" }}>
            <li><strong>Inefisiensi Biaya:</strong> Penyimpanan yang tidak digunakan membuang biaya tanpa manfaat signifikan.</li>
            <li><strong>Potensi Overprovisioning:</strong> Kapasitas berlebih menciptakan sumber daya yang terbuang.</li>
          </ul>
          <br />
          <p>Dampak pada komponen lain:</p>
          <ul style={{ listStyleType: "disc", paddingLeft: "20px" }}>
            <li><strong>Quality of Service (QoS):</strong> Penyimpanan yang tidak dimanfaatkan dapat digunakan untuk mempercepat layanan dan meningkatkan kualitas jaringan.</li>
            <li><strong>Traffic:</strong> Kapasitas penyimpanan yang tersedia dapat dialihkan untuk mendukung kebutuhan lalu lintas tinggi.</li>
          </ul>
        </div>
      ),
      solution: (
        <div>
          <p>
            Berikut adalah langkah-langkah yang bisa Anda lakukan untuk mengatasi
            Storage yang underutilized atau underload:
          </p>
          <ol style={{ listStyleType: "decimal", paddingLeft: "20px" }}>
            <li>
              <strong>Fungsi Router Dasar</strong>
              <ul style={{ listStyleType: "disc", paddingLeft: "20px" }}>
                <li>
                  Router yang hanya digunakan untuk routing dan NAT dasar biasanya
                  tidak membutuhkan banyak storage. Sebagian besar ruang
                  penyimpanan akan digunakan untuk sistem operasi, log minimal,
                  atau konfigurasi.
                </li>
                <li>
                  Solusi: Jika fungsi dasar sudah mencukupi, tidak perlu khawatir.
                  Namun, Anda bisa mempertimbangkan fitur tambahan seperti detail
                  logging atau caching untuk mengoptimalkan storage Anda.
                </li>
              </ul>
              <div></div>
            </li>
            <li>
              <strong>Kapasitas Storage Berlebihan</strong>
              <ul style={{ listStyleType: "disc", paddingLeft: "20px" }}>
                <li>
                  Router modern seringkali dilengkapi dengan storage besar untuk
                  mendukung fitur tambahan seperti logging, caching, atau aplikasi
                  tambahan. Jika fitur ini tidak diaktifkan, storage akan tampak
                  underutilized.
                </li>
                <li>
                  Solusi: Evaluasi apakah ada fitur yang bisa diaktifkan, seperti
                  log traffic, DNS caching, atau QoS monitoring. Pertimbangkan
                  penggunaan penyimpanan untuk file konfigurasi cadangan atau
                  firmware.
                </li>
              </ul>
              <div></div>
            </li>
            <li>
              <strong>Logging Tidak Diaktifkan</strong>
              <ul style={{ listStyleType: "disc", paddingLeft: "20px" }}>
                <li>
                  Router menggunakan storage untuk menyimpan log aktivitas
                  jaringan, seperti traffic, peristiwa keamanan, atau konfigurasi
                  sistem. Jika logging dimatikan atau diarahkan ke server
                  eksternal, storage akan kosong.
                </li>
                <li>
                  Solusi: Aktifkan logging pada router untuk pemantauan jaringan.
                  Simpan log di penyimpanan lokal untuk analisis atau
                  troubleshooting di masa depan. Catatan: Hati-hati agar log tidak
                  terlalu besar hingga membebani storage.
                </li>
              </ul>
              <div></div>
            </li>
            <li>
              <strong>Tidak Menggunakan Fitur Caching</strong>
              <ul style={{ listStyleType: "disc", paddingLeft: "20px" }}>
                <li>
                  Beberapa router mendukung caching untuk DNS, ARP, atau data lain
                  guna meningkatkan kinerja. Jika caching dimatikan, storage akan
                  kurang dimanfaatkan.
                </li>
                <li>
                  Solusi: Aktifkan fitur caching jika router mendukung, terutama
                  untuk jaringan dengan banyak permintaan DNS atau lalu lintas
                  berulang.
                </li>
              </ul>
              <div></div>
            </li>
            <li>
              <strong>Tidak Ada Penggunaan Firmware atau Add-On Ekstra</strong>
              <ul style={{ listStyleType: "disc", paddingLeft: "20px" }}>
                <li>
                  Beberapa router mendukung instalasi aplikasi tambahan seperti
                  VPN server, IDS/IPS, atau monitoring. Jika aplikasi tambahan
                  tidak digunakan, storage akan kosong.
                </li>
                <li>
                  Solusi: Instal aplikasi tambahan jika memungkinkan dan relevan
                  untuk kebutuhan jaringan Anda. Perbarui firmware secara berkala,
                  dan simpan beberapa versi cadangan di storage untuk rollback
                  jika terjadi masalah.
                </li>
              </ul>
              <div></div>
            </li>
            <li>
              <strong>Kapasitas Backup atau Konfigurasi</strong>
              <ul style={{ listStyleType: "disc", paddingLeft: "20px" }}>
                <li>
                  Storage dapat digunakan untuk menyimpan file konfigurasi, backup
                  sistem, atau skrip otomatisasi jaringan.
                </li>
                <li>
                  Solusi: Simpan cadangan konfigurasi penting di storage router.
                  Buat skrip otomatisasi untuk tugas administratif (jika router
                  mendukung scripting).
                </li>
              </ul>
              <div></div>
            </li>
            <li>
              <strong>Menggunakan Penyimpanan untuk File Berbagi</strong>
              <ul style={{ listStyleType: "disc", paddingLeft: "20px" }}>
                <li>
                  Beberapa router dengan fitur USB storage atau network-attached
                  storage (NAS) dapat digunakan untuk berbagi file di jaringan
                  lokal.
                </li>
                <li>
                  Solusi: Jika router Anda mendukung fitur ini, gunakan storage
                  untuk berbagi dokumen, media, atau file penting di jaringan.
                </li>
              </ul>
              <div></div>
            </li>
          </ol>
        </div>
      )
    },
    traffic: {
      title: "Traffic",
      definition: (
        <div>
          <ul style={{ listStyleType: "disc", paddingLeft: "20px" }}>
            <li>Traffic In adalah data yang diterima oleh jaringan atau perangkat dari sumber eksternal. Contohnya, ketika Anda mengunduh file, streaming video, atau menerima email.</li>
            <li>Traffic Out adalah data yang dikirim dari jaringan atau perangkat ke sumber eksternal. Misalnya, mengunggah file, mengirim email, atau mengakses halaman web.</li>
          </ul>
        </div>
      ),
      analysis: (
        <div>
          <p> Dampak umum:</p>
          <ul style={{ listStyleType: "disc", paddingLeft: "20px" }}>
            <li><strong>Penurunan Kualitas Layanan:</strong> Gangguan traffic dapat memperlambat pengiriman data, meningkatkan latensi, dan menurunkan kualitas layanan.</li>
          </ul>
          <br />
          <p> Dampak pada komponen lain:</p>
          <ul style={{ listStyleType: "disc", paddingLeft: "20px" }}>
            <li><strong>Device Capacity:</strong> Gangguan traffic dapat memperlambat pemrosesan data, mengurangi kinerja perangkat dan efisiensi jaringan.</li>
            <li><strong>QoS (Quality of Service):</strong> Penurunan traffic dapat menurunkan kualitas layanan, meningkatkan latensi, dan mengurangi performa aplikasi real-time.</li>
          </ul>
        </div>
      ),
      solution: (
        <div>
          <p> Berikut adalah langkah-langkah yang bisa Anda lakukan untuk mengatasi masalah Traffic:</p>
          <ol style={{ listStyleType: "decimal", paddingLeft: "20px" }}>
            <li style={{ listStyleType: "disc", paddingLeft: "20px" }}>
              <strong>Identifikasi Penyebab Traffic Tinggi</strong>
              <ul style={{ listStyleType: "disc", paddingLeft: "20px" }}>
                <li>
                  Gunakan Monitoring Tools: Gunakan perangkat lunak atau fitur
                  bawaan router untuk memantau aktivitas jaringan (seperti
                  perangkat dan aplikasi yang paling banyak mengonsumsi data).
                </li>
                <li>
                  Periksa Perangkat di Jaringan: Pastikan perangkat yang
                  terkoneksi ke router adalah milik pengguna resmi. Periksa
                  apakah ada perangkat mencurigakan.
                </li>
              </ul>
              <div></div>
            </li>
            <li style={{ listStyleType: "disc", paddingLeft: "20px" }}>
              <strong>Optimasi dan Kontrol Bandwidth</strong>
              <ul style={{ listStyleType: "disc", paddingLeft: "20px" }}>
                <li>
                  Prioritaskan Aplikasi Penting: Aktifkan fitur Quality of Service
                  (QoS) di router untuk mengutamakan aplikasi penting seperti
                  video conference atau pekerjaan online.
                </li>
                <li>
                  Batasi Bandwidth untuk Aplikasi Berat: Blokir atau batasi
                  penggunaan bandwidth untuk aplikasi atau layanan tertentu yang
                  tidak perlu.
                </li>
                <li>
                  Blokir Perangkat Tak Dikenal: Jika ditemukan perangkat yang
                  tidak dikenal, segera blokir melalui pengaturan router.
                </li>
              </ul>
              <div></div>
            </li>
            <li style={{ listStyleType: "disc", paddingLeft: "20px" }}>
              <strong>Amankan Jaringan Anda</strong>
              <ul style={{ listStyleType: "disc", paddingLeft: "20px" }}>
                <li>
                  Ubah Kata Sandi Wi-Fi: Jika traffic tinggi disebabkan oleh
                  pengguna tak sah, ubah kata sandi dan gunakan protokol enkripsi
                  yang lebih kuat (misalnya WPA3).
                </li>
                <li>
                  Perbarui Firmware Router: Pastikan router Anda menjalankan
                  firmware terbaru untuk melindungi dari kerentanan keamanan.
                </li>
                <li>
                  Aktifkan Firewall: Gunakan fitur firewall di router untuk
                  memblokir traffic yang mencurigakan.
                </li>
              </ul>
              <div></div>
            </li>
            <li style={{ listStyleType: "disc", paddingLeft: "20px" }}>
              <strong>Cegah Serangan Jaringan</strong>
              <ul style={{ listStyleType: "disc", paddingLeft: "20px" }}>
                <li>
                  Deteksi Serangan DDoS: Traffic in yang tinggi bisa jadi tanda
                  serangan Distributed Denial of Service (DDoS). Gunakan layanan
                  anti-DDoS atau hubungi ISP Anda untuk bantuan.
                </li>
                <li>
                  Blokir IP Mencurigakan: Jika Anda mendeteksi traffic mencurigakan
                  dari alamat IP tertentu, gunakan pengaturan router untuk
                  memblokir IP tersebut.
                </li>
              </ul>
              <div></div>
            </li>
            <li style={{ listStyleType: "disc", paddingLeft: "20px" }}>
              <strong>Periksa ISP atau Penyedia Layanan</strong>
              <ul style={{ listStyleType: "disc", paddingLeft: "20px" }}>
                <li>
                  Konsultasi ISP: Jika traffic tetap tinggi setelah semua langkah
                  di atas, hubungi penyedia layanan internet Anda untuk memeriksa
                  apakah ada anomali dari sisi mereka.
                </li>
                <li>
                  Upgrade Paket Internet: Jika penggunaan jaringan Anda meningkat
                  secara wajar, pertimbangkan untuk meningkatkan paket bandwidth
                  Anda.
                </li>
              </ul>
              <div></div>
            </li>
          </ol>
        </div>
      )        
    },
    process : {
      title: "Process",
      definition: (
        <p> lorem ipsum</p>
      ),
      analysis: (
        <p> lorem ipsum</p>
      ),
      solution: (
        <p> lorem ipsum</p>
      )
    },
    container: {
      title: "Container",
      definition: (
        <p> lorem ipsum</p>
      ),
      analysis: (
        <p> lorem ipsum</p>
      ),
      solution: (
        <p> lorem ipsum</p>
      )
    },
    cpuServer: {
      title: "CPU",
      definition: (
        <div>
          <ul style={{ listStyleType: "disc", paddingLeft: "20px" }}>
            <li> CPU (Central Processing Unit) adalah komponen utama yang menjalankan instruksi dan proses untuk mengoperasikan perangkat jaringan seperti router, switch, atau server.</li>
            <li> CPU hampir penuh  terjadi ketika berada dalam status warning (penggunaan{' >'} 50%) dan status critical (penggunaan {'>'} 80%), yang menunjukkan bahwa perangkat hampir mencapai batas kapasitasnya, sehingga kinerja perangkat dapat terganggu atau terhambat.</li>
          </ul>
        </div>
      ),
      analysis: (
        <div>
          <p>Jika kapasitas CPU hampir penuh:</p>

          <ul style={{ listStyleType: "disc", paddingLeft: "20px" }}>
            <li><strong>Kinerja Menurun:</strong> Perangkat menjadi lambat karena CPU sulit memproses data.</li>
            <li><strong>Gangguan Layanan:</strong> Operasional jaringan terganggu, menyebabkan keterlambatan atau downtime.</li>
            <li><strong>Potensi Crash:</strong> Beban tinggi dapat membuat perangkat gagal beroperasi.</li>
            <li><strong>Efek Sistem:</strong> Perangkat lain dalam jaringan terkena dampak, memperburuk kinerja keseluruhan.</li>
          </ul>

          <br />

        </div>
      ),
      solution: (
        <div>
          <p>
            Lakukan langkah-langkah ini untuk mengatasi masalah CPU Perangkat:
          </p>
          <ol style={{ listStyleType: "decimal", paddingLeft: "20px" }}>
            <li>Redistribusikan beban kerja ke node lain yang kurang sibuk.</li>
            <li>
              Optimalkan aplikasi yang berjalan untuk mengurangi penggunaan CPU.
            </li>
            <li>
              Tingkatkan kapasitas CPU dengan menambahkan prosesor atau core
              tambahan.
            </li>
            <li>
              Nonaktifkan atau hentikan aplikasi yang tidak penting atau
              berlebihan.
            </li>
            <li>
              Gunakan load balancer untuk mengelola dan mendistribusikan lalu
              lintas secara lebih efisien.
            </li>
          </ol>
        </div>
      )
    },
    cpuUnderutilizedServer: {
      title: "CPU Underutilized",
      definition: (
        <div>
          <ul style={{ listStyleType: "disc", paddingLeft: "20px" }}>
            <li>CPU (Central Processing Unit) adalah komponen utama yang menjalankan instruksi dan proses untuk mengoperasikan perangkat jaringan seperti router, switch, atau server.</li>
            <li>CPU Underutilization terjadi ketika penggunaan CPU {"<"} 30%, menunjukkan perangkat tidak dimanfaatkan secara optimal, sehingga banyak kapasitas yang terbuang.</li>
          </ul>
        </div>
      ),
      analysis: (
        <div>
          <p> Jika CPU underutilized:</p>
          <ul style={{ listStyleType: "disc", paddingLeft: "20px" }}>
            <li><strong>Efisiensi Rendah:</strong> Kapasitas perangkat terbuang sia-sia.</li>
            <li><strong>Konsumsi Daya Berlebihan:</strong> Perangkat tetap aktif tetapi tidak memberikan performa optimal.</li>
            <li><strong>Biaya Operasional Tinggi:</strong> Penggunaan perangkat tidak sesuai dengan potensi sebenarnya.</li>
          </ul>
          
        </div>
      ),
      solution: (
        <div>

          <p>
            Berikut adalah langkah-langkah yang bisa Anda lakukan untuk mengatasi
            CPU yang underutilized atau underload:
          </p>
          <ol style={{ listStyleType: "decimal", paddingLeft: "20px" }}>
            <li>
              <strong>Lalu Lintas Jaringan Rendah</strong>
              <ul style={{ listStyleType: "disc", paddingLeft: "20px" }}>
                <li>
                  Jika lalu lintas jaringan tidak terlalu tinggi, CPU router
                  mungkin tidak perlu bekerja keras. Biasanya, ini terjadi pada
                  jam-jam sepi atau ketika jaringan tidak banyak digunakan.
                </li>
                <li>
                  Solusi: Coba lakukan pemantauan saat lalu lintas jaringan sedang
                  tinggi, atau gunakan alat simulasi lalu lintas untuk menguji
                  performa pada beban lebih tinggi.
                </li>
              </ul>
              <div></div>
            </li>
            <li>
              <strong>
                Spesifikasi Router yang Terlalu Tinggi untuk Kebutuhan
              </strong>
              <ul style={{ listStyleType: "disc", paddingLeft: "20px" }}>
                <li>
                  CPU router yang terlalu kuat untuk kebutuhan jaringan saat ini
                  bisa menyebabkan underutilized, terutama jika hanya digunakan
                  untuk routing dasar tanpa fitur tambahan.
                </li>
                <li>
                  Solusi: Pastikan bahwa spesifikasi router sesuai dengan
                  kebutuhan jaringan. Jika router mendukung fitur-fitur tambahan
                  seperti firewall atau VPN, pertimbangkan untuk mengaktifkan
                  fitur tersebut guna meningkatkan pemanfaatan CPU.
                </li>
              </ul>
              <div></div>
            </li>
            <li>
              <strong>Konfigurasi yang Kurang Optimal</strong>
              <ul style={{ listStyleType: "disc", paddingLeft: "20px" }}>
                <li>
                  Beberapa konfigurasi bisa menyebabkan lalu lintas tidak
                  terdistribusi secara merata ke semua core CPU yang tersedia,
                  sehingga membuat pemanfaatan CPU rendah.
                </li>
                <li>
                  Solusi: Cek konfigurasi load balancing atau distribusi beban,
                  terutama jika router memiliki multi-core CPU. Pastikan bahwa
                  tugas-tugas berat seperti NAT atau VPN dapat didistribusikan
                  dengan baik ke semua core.
                </li>
              </ul>
              <div></div>
            </li>
            <li>
              <strong>Adanya Bottleneck pada Komponen Lain</strong>
              <ul style={{ listStyleType: "disc", paddingLeft: "20px" }}>
                <li>
                  Underutilized bisa juga terjadi jika ada bottleneck atau
                  hambatan pada komponen lain seperti memori atau port jaringan ,
                  yang membatasi performa keseluruhan meskipun CPU tidak
                  terbebani.
                </li>
                <li>
                  Solusi: Periksa penggunaan memori dan kapasitas port jaringan
                  untuk memastikan tidak ada yang menjadi hambatan. Jika perlu,
                  lakukan upgrade atau sesuaikan setting agar semua komponen dapat
                  bekerja secara optimal.
                </li>
              </ul>
              <div></div>
            </li>
            <li>
              <strong>Optimalkan Penggunaan Fitur Router</strong>
              <ul style={{ listStyleType: "disc", paddingLeft: "20px" }}>
                <li>
                  Jika router memiliki kemampuan fitur tambahan (seperti IDS/IPS,
                  firewall tingkat lanjut, QoS), mengaktifkan fitur ini dapat
                  meningkatkan pemanfaatan CPU.
                </li>
                <li>
                  Solusi: Aktifkan fitur-fitur tambahan sesuai kebutuhan jaringan,
                  misalnya dengan mengaktifkan inspeksi paket, kontrol lalu
                  lintas, atau fitur keamanan untuk memaksimalkan penggunaan
                  router.
                </li>
              </ul>
              <div></div>
            </li>
          </ol>
        </div>
      )
    },
    memoryServer: {
      title: "Memory",
      definition: (
        <div>
          <ul style={{ listStyleType: "disc", paddingLeft: "20px" }}>
            <li>RAM (Random Access Memory) adalah memori sementara yang digunakan perangkat jaringan untuk menyimpan dan mengakses data secara cepat.</li>
            <li>RAM hampir penuh terjadi ketika berada dalam status warning (penggunaan {'>'} 50%) dan status critical (penggunaan {'>'} 80%), yang menunjukkan bahwa perangkat hampir mencapai batas kapasitasnya, sehingga kinerja perangkat dapat terganggu atau terhambat.</li>
          </ul>
        </div>),
      analysis: (
        <div>
          <p>Jika kapasitas Memory hampir penuh:</p>
          <ul style={{ listStyleType: "disc", paddingLeft: "20px" }}>
            <li><strong>Kinerja Menurun:</strong> Proses data menjadi lebih lambat, memengaruhi respons perangkat.</li>
            <li><strong>Gangguan Layanan:</strong> Layanan jaringan terhambat, menyebabkan keterlambatan atau downtime.</li>
            <li><strong>Risiko Crash:</strong> Kelebihan memori dapat membuat perangkat tidak stabil atau gagal beroperasi.</li>
            <li><strong>Efek Sistemik:</strong> Perangkat lain dalam jaringan ikut terdampak, memperburuk kinerja keseluruhan.</li>
          </ul>
          <br />
          
        </div>
      ),
      solution: (
        <div>
          <p>
            Lakukan langkah-langkah ini untuk mengatasi masalah Memory Perangkat:
          </p>
          <ol style={{ listStyleType: "decimal", paddingLeft: "20px" }}>
            <li> Tingkatkan kapasitas Memory pada node yang terkena dampak.</li>
            <li>
              Identifikasi dan optimalkan aplikasi yang menggunakan banyak Memory.
            </li>
            <li>Hentikan aplikasi yang tidak perlu untuk membebaskan Memory.</li>
            <li>
              Gunakan teknik paging atau swap yang lebih efisien jika
              memungkinkan.
            </li>
            <li>
              Distribusikan aplikasi ke node lain dengan Memory yang lebih rendah
              penggunaannya.
            </li>
          </ol>
        </div>
      )
    },
    memoryUnderutilizedServer: {
      title: "Memory Underutilized",
      definition: (
        <div>
          <ul style={{ listStyleType: "disc", paddingLeft: "20px" }}>
            <li>RAM (Random Access Memory) adalah memori sementara yang digunakan perangkat jaringan untuk menyimpan dan mengakses data secara cepat.</li>
            <li>RAM Underutilization terjadi ketika penggunaan memory {"<"} 30%, menunjukkan perangkat tidak dimanfaatkan secara optimal, sehingga banyak kapasitas yang terbuang.</li>
          </ul>
        </div>
      ),
      analysis: (
        <div>
          <p> Jika kapasitas Memory underutilized:</p>
          <ul style={{ listStyleType: "disc", paddingLeft: "20px" }}>
            <li><strong>Efisiensi Rendah:</strong> Kapasitas perangkat tidak dimanfaatkan secara optimal.</li>
            <li><strong>Konsumsi Daya Tidak Efisien:</strong> Perangkat tetap aktif meski sumber daya tidak digunakan secara efektif.</li>
            <li><strong>Biaya Operasional Tinggi:</strong> Penggunaan perangkat tidak sesuai dengan kebutuhan aktual.</li>
          </ul>
          <br />
        
        </div>

      ),
      solution: (
        <div>
          <p>
            Berikut adalah langkah-langkah yang bisa Anda lakukan untuk mengatasi
            RAM yang underutilized atau underload:
          </p>
          <ol style={{ listStyleType: "decimal", paddingLeft: "20px" }}>
            <li>
              <strong>⁠Perangkat Tidak Dikonfigurasi untuk Beban Maksimum</strong>
              <ul style={{ listStyleType: "disc", paddingLeft: "20px" }}>
                <li>
                  Jika perangkat hanya menjalankan fungsi dasar (seperti routing
                  atau NAT sederhana) tanpa fitur tambahan seperti firewall, QoS,
                  atau VPN. RAM mungkin tidak digunakan secara optimal.
                </li>
                <li>
                  Solusi: Aktifkan fitur tambahan yang relevan, seperti inspeksi
                  paket (DPI), Quality of Service (QoS), atau log traffic .
                  Sesuaikan konfigurasi untuk memanfaatkan fitur yang mendukung
                  stabilitas dan keamanan jaringan.
                </li>
              </ul>
              <div></div>
            </li>
            <li>
              <strong>⁠Spesifikasi Perangkat Berlebihan untuk Kebutuhan</strong>
              <ul style={{ listStyleType: "disc", paddingLeft: "20px" }}>
                <li>
                  Router dengan RAM besar mungkin dirancang untuk menangani beban
                  jaringan yang jauh lebih tinggi daripada yang Anda miliki saat
                  ini.
                </li>
                <li>
                  Solusi: Evaluasi kebutuhan jaringan. Jika kebutuhan jaringan
                  Anda kecil, mungkin cukup menggunakan perangkat dengan
                  spesifikasi yang lebih rendah. Namun, jika ada rencana untuk
                  ekspansi jaringan, tidak perlu dilakukan tindakan khusus, karena
                  ekstra RAM akan bermanfaat di masa depan.
                </li>
              </ul>
              <div></div>
            </li>
            <li>
              <strong>⁠Traffic Jaringan Ringan</strong>
              <ul style={{ listStyleType: "disc", paddingLeft: "20px" }}>
                <li>
                  Jika jaringan Anda tidak terlalu sibuk atau tidak banyak
                  perangkat terhubung, perangkat mungkin tidak dapat memanfaatkan
                  RAM secara maksimal.
                </li>
                <li>
                  Solusi: Uji performa perangkat pada beban traffic yang lebih
                  tinggi. Simulasikan traffic menggunakan alat seperti iPerf atau
                  trafgen untuk melihat bagaimana memori digunakan dalam kondisi
                  berat.
                </li>
              </ul>
              <div></div>
            </li>
            <li>
              <strong>⁠Cache Tidak Dimanfaatkan Secara Optimal</strong>
              <ul style={{ listStyleType: "disc", paddingLeft: "20px" }}>
                <li>
                  RAM perangkat sering digunakan untuk caching (seperti ARP cache,
                  DNS cache, atau buffering). Jika cache kecil, RAM tidak terpakai
                  optimal.
                </li>
                <li>
                  Solusi: Perbesar ukuran cache DNS, ARP, atau buffer paket jika
                  perangkat mendukung pengaturan tersebut. Jika Anda menggunakan
                  fitur seperti Content Filtering atau Proxy, sesuaikan agar
                  memori dapat digunakan lebih baik.
                </li>
              </ul>
              <div></div>
            </li>
            <li>
              <strong>Tidak Ada Fitur Log yang Aktif</strong>
              <ul style={{ listStyleType: "disc", paddingLeft: "20px" }}>
                <li>
                  Logging aktivitas jaringan menggunakan RAM. Jika logging
                  dimatikan, RAM akan tetap kosong.
                </li>
                <li>
                  Solusi: Aktifkan logging lalu lintas untuk tujuan monitoring
                  atau analisis. Pastikan penggunaan logging tidak membebani
                  performa secara berlebihan.
                </li>
              </ul>
              <div></div>
            </li>
            <li>
              <strong>⁠Potensi Bottleneck pada Komponen Lain</strong>
              <ul style={{ listStyleType: "disc", paddingLeft: "20px" }}>
                <li>
                  Jika komponen lain seperti CPU atau port jaringan menjadi
                  bottleneck, router tidak dapat memanfaatkan RAM secara maksimal.
                </li>
                <li>
                  Solusi: Analisis performa perangkat secara keseluruhan. Jika CPU
                  atau bandwidth port terlalu rendah, pertimbangkan upgrade router
                  atau optimasi konfigurasi.
                </li>
              </ul>
              <div></div>
            </li>
          </ol>
        </div>
      )
    },
    storageServer: {
      title: "Storage",
      definition: (
        <div>
          <ul style={{ listStyleType: "disc", paddingLeft: "20px" }}>
            <li>Storage (Penyimpanan) adalah kapasitas untuk menyimpan data pada perangkat jaringan, seperti HDD atau SSD, yang menyimpan data, konfigurasi, dan log penting untuk operasi perangkat.</li>
            <li>Storage hampir penuh terjadi ketika berada dalam status warning (penggunaan {'>'} 50%) dan status critical (penggunaan {'>'} 80%), yang menunjukkan bahwa perangkat hampir mencapai batas kapasitasnya, sehingga kinerja perangkat dapat terganggu atau terhambat.</li>

          </ul>
        </div>
      ),
      analysis: (
        <div>
          <p> Jika kapasitas storage hampir penuh:</p>
          <ul style={{ listStyleType: "disc", paddingLeft: "20px" }}>
            <li><strong>Penurunan Kinerja:</strong> Penyimpanan penuh dapat memperlambat pemrosesan data.</li>
            <li><strong>Gangguan Operasional:</strong> Data baru tidak dapat disimpan, menyebabkan kegagalan sistem atau aplikasi.</li>
            <li><strong>Potensi Kehilangan Data:</strong> Risiko kehilangan data penting meningkat karena penyimpanan tidak mencukupi.</li>
          </ul>
          
        </div>
      ),
      solution: (
        <div>
          <p>
            Lakukan langkah-langkah ini untuk mengatasi masalah Storage Perangkat:
          </p>
          <ol style={{ listStyleType: "decimal", paddingLeft: "20px" }}>
            <li>
              {" "}
              Hapus atau arsipkan data yang tidak diperlukan untuk mengosongkan
              ruang storage.
            </li>
            <li>
              Optimalkan penggunaan storage dengan mengompresi data jika
              memungkinkan.
            </li>
            <li>
              Pindahkan data yang jarang diakses ke penyimpanan yang lebih lambat
              atau murah.
            </li>
            <li>
              Tingkatkan kapasitas storage dengan menambahkan drive baru atau
              meningkatkan kapasitas drive yang ada.
            </li>
            <li>
              Implementasikan kebijakan retensi data yang lebih ketat untuk
              membatasi jumlah data yang disimpan.
            </li>
          </ol>
        </div>
      )
    },
    storageUnderutilizedServer: {
      title: "Storage Underutilized",
      definition: (
        <div>
          <ul style={{ listStyleType: "disc", paddingLeft: "20px" }}>
            <li>Storage (Penyimpanan) adalah kapasitas untuk menyimpan data pada perangkat jaringan, seperti HDD atau SSD, yang menyimpan data, konfigurasi, dan log penting untuk operasi perangkat.</li>
            <li>Storage Underutilization terjadi ketika penggunaan storage {'<'} 30%, menunjukkan perangkat tidak dimanfaatkan secara optimal, sehingga banyak kapasitas yang terbuang.</li>
          </ul>
        </div>
      ),
      analysis: (
        <div>
          <p>Jika storage underutilized:</p>
          <ul style={{ listStyleType: "disc", paddingLeft: "20px" }}>
            <li><strong>Inefisiensi Biaya:</strong> Penyimpanan yang tidak digunakan membuang biaya tanpa manfaat signifikan.</li>
            <li><strong>Potensi Overprovisioning:</strong> Kapasitas berlebih menciptakan sumber daya yang terbuang.</li>
          </ul>
          <br />
          
        </div>
      ),
      solution: (
        <div>
          <p>
            Berikut adalah langkah-langkah yang bisa Anda lakukan untuk mengatasi
            Storage yang underutilized atau underload:
          </p>
          <ol style={{ listStyleType: "decimal", paddingLeft: "20px" }}>
            <li>
              <strong>Fungsi Router Dasar</strong>
              <ul style={{ listStyleType: "disc", paddingLeft: "20px" }}>
                <li>
                  Router yang hanya digunakan untuk routing dan NAT dasar biasanya
                  tidak membutuhkan banyak storage. Sebagian besar ruang
                  penyimpanan akan digunakan untuk sistem operasi, log minimal,
                  atau konfigurasi.
                </li>
                <li>
                  Solusi: Jika fungsi dasar sudah mencukupi, tidak perlu khawatir.
                  Namun, Anda bisa mempertimbangkan fitur tambahan seperti detail
                  logging atau caching untuk mengoptimalkan storage Anda.
                </li>
              </ul>
              <div></div>
            </li>
            <li>
              <strong>Kapasitas Storage Berlebihan</strong>
              <ul style={{ listStyleType: "disc", paddingLeft: "20px" }}>
                <li>
                  Router modern seringkali dilengkapi dengan storage besar untuk
                  mendukung fitur tambahan seperti logging, caching, atau aplikasi
                  tambahan. Jika fitur ini tidak diaktifkan, storage akan tampak
                  underutilized.
                </li>
                <li>
                  Solusi: Evaluasi apakah ada fitur yang bisa diaktifkan, seperti
                  log traffic, DNS caching, atau QoS monitoring. Pertimbangkan
                  penggunaan penyimpanan untuk file konfigurasi cadangan atau
                  firmware.
                </li>
              </ul>
              <div></div>
            </li>
            <li>
              <strong>Logging Tidak Diaktifkan</strong>
              <ul style={{ listStyleType: "disc", paddingLeft: "20px" }}>
                <li>
                  Router menggunakan storage untuk menyimpan log aktivitas
                  jaringan, seperti traffic, peristiwa keamanan, atau konfigurasi
                  sistem. Jika logging dimatikan atau diarahkan ke server
                  eksternal, storage akan kosong.
                </li>
                <li>
                  Solusi: Aktifkan logging pada router untuk pemantauan jaringan.
                  Simpan log di penyimpanan lokal untuk analisis atau
                  troubleshooting di masa depan. Catatan: Hati-hati agar log tidak
                  terlalu besar hingga membebani storage.
                </li>
              </ul>
              <div></div>
            </li>
            <li>
              <strong>Tidak Menggunakan Fitur Caching</strong>
              <ul style={{ listStyleType: "disc", paddingLeft: "20px" }}>
                <li>
                  Beberapa router mendukung caching untuk DNS, ARP, atau data lain
                  guna meningkatkan kinerja. Jika caching dimatikan, storage akan
                  kurang dimanfaatkan.
                </li>
                <li>
                  Solusi: Aktifkan fitur caching jika router mendukung, terutama
                  untuk jaringan dengan banyak permintaan DNS atau lalu lintas
                  berulang.
                </li>
              </ul>
              <div></div>
            </li>
            <li>
              <strong>Tidak Ada Penggunaan Firmware atau Add-On Ekstra</strong>
              <ul style={{ listStyleType: "disc", paddingLeft: "20px" }}>
                <li>
                  Beberapa router mendukung instalasi aplikasi tambahan seperti
                  VPN server, IDS/IPS, atau monitoring. Jika aplikasi tambahan
                  tidak digunakan, storage akan kosong.
                </li>
                <li>
                  Solusi: Instal aplikasi tambahan jika memungkinkan dan relevan
                  untuk kebutuhan jaringan Anda. Perbarui firmware secara berkala,
                  dan simpan beberapa versi cadangan di storage untuk rollback
                  jika terjadi masalah.
                </li>
              </ul>
              <div></div>
            </li>
            <li>
              <strong>Kapasitas Backup atau Konfigurasi</strong>
              <ul style={{ listStyleType: "disc", paddingLeft: "20px" }}>
                <li>
                  Storage dapat digunakan untuk menyimpan file konfigurasi, backup
                  sistem, atau skrip otomatisasi jaringan.
                </li>
                <li>
                  Solusi: Simpan cadangan konfigurasi penting di storage router.
                  Buat skrip otomatisasi untuk tugas administratif (jika router
                  mendukung scripting).
                </li>
              </ul>
              <div></div>
            </li>
            <li>
              <strong>Menggunakan Penyimpanan untuk File Berbagi</strong>
              <ul style={{ listStyleType: "disc", paddingLeft: "20px" }}>
                <li>
                  Beberapa router dengan fitur USB storage atau network-attached
                  storage (NAS) dapat digunakan untuk berbagi file di jaringan
                  lokal.
                </li>
                <li>
                  Solusi: Jika router Anda mendukung fitur ini, gunakan storage
                  untuk berbagi dokumen, media, atau file penting di jaringan.
                </li>
              </ul>
              <div></div>
            </li>
          </ol>
        </div>
      )
    },
    webapi: {
      title: "Web API",
      definition: (
        <div>
          <ul style={{ listStyleType: "disc", paddingLeft: "20px" }}>
            <li>Response Time adalah waktu yang diperlukan untuk menerima respons dari server setelah permintaan (request) dikirim melalui sebuah antarmuka pemrograman aplikasi (API) atau website. Ini mencakup durasi dari saat permintaan dikirim oleh klien (misalnya browser, aplikasi, atau alat integrasi) hingga respons diterima dan diolah.</li>
          </ul>
        </div>
      ),
      analysis: (
        <div>
          <p> Faktor yang mempengaruhi Response Time Web/API antara lain:</p>
          <ol style={{ listStyleType: "decimal", paddingLeft: "20px" }}>
            <li><strong>Kecepatan dan performa server:</strong> Kapasitas server dalam menangani permintaan.</li>
            <li><strong>Jumlah permintaan / request user:</strong> Lonjakan traffik dapat memperlambat respons.</li>
            <li><strong>Jarak geografis:</strong> Semakin jauh posisi server dari klien, maka semakin besar latensi yang diperoleh.</li>
            <li><strong>Optimisasi kode:</strong> Struktur dan efisiensi kode backend atau layanan.</li>
            <li><strong>Kinerja jaringan:</strong> Stabilitas dan kecepatan jaringan internet.</li>
            <li><strong>Cache:</strong> Penggunaan caching untuk mengurangi beban pemrosesan server.</li>
          </ol>
          < br />
          <p> Dampak dari Web/API Response Time yang tinggi:</p>
          <ol style={{ listStyleType: "decimal", paddingLeft: "20px" }}>
            <li><strong>Penurunan Kepuasan Pengguna:</strong> Pengguna cenderung merasa frustrasi jika halaman web atau respons API membutuhkan waktu terlalu lama.</li>
            <li><strong>Peningkatan Bounce Rate:</strong> Jika situs atau aplikasi lambat, pengguna mungkin meninggalkan platform sebelum menyelesaikan tugas mereka.</li>
            <li><strong>Reputasi Buruk:</strong> Pengalaman yang buruk dapat menyebar melalui ulasan negatif atau word-of-mouth.</li>
            <li><strong>Kehilangan Pelanggan:</strong> Pelanggan mungkin beralih ke kompetitor yang menawarkan layanan lebih cepat.</li>
            <li><strong>Penurunan Konversi:</strong> Setiap penundaan 1 detik dapat menurunkan konversi hingga 7%.</li>
            <li><strong>Kerugian Pendapatan:</strong> Respons yang lambat dapat mengurangi transaksi dan pembelian.</li>
            <li><strong>Biaya Operasional Tambahan:</strong> Response time yang lambat sering kali memerlukan investigasi, debugging, dan optimisasi yang memakan biaya.</li>
            <li><strong>Beban Server Lebih Tinggi:</strong> Permintaan yang memerlukan waktu lama sering kali memakan lebih banyak sumber daya server, seperti CPU dan RAM.</li>
            <li><strong>Kemacetan Sistem:</strong> Permintaan yang tertunda dapat menyebabkan antrean (queue) pada sistem, memperparah performa keseluruhan.</li>
            <li><strong>Penurunan Peringkat di Mesin Pencari:</strong> Google memprioritaskan situs dengan waktu muat cepat. Response time sering kali memerlukan investigasi, debugging, dan optimisasi yang memakan biaya.</li>

            <li><strong>Pengurangan Crawl Rate:</strong> Bot mesin pencari seperti Googlebot mungkin mengurangi frekuensi kunjungan ke situs yang lambat.</li>
          </ol>

        </div>
      ),
      solution: (
        <div>
          <p>
            Jika power perangkat mati, maka Anda dapat melakukan beberapa langkah sebagai berikut:
          </p>
            <ol style={{ listStyleType: "decimal", paddingLeft: "20px" }}>
              <li style={{ listStyleType: "disc", paddingLeft: "20px" }}>
                <strong>Optimisasi Backend</strong>
                <ul style={{ listStyleType: "disc", paddingLeft: "20px" }}>
                  <li>Query Database yang Efisien: 
                    <ul style={{ listStyleType: "circle", paddingLeft: "20px" }}>
                      <li>Gunakan indeks pada kolom yang sering digunakan dalam pencarian.</li>
                      <li>Hindari query berulang; gabungkan query jika memungkinkan.</li>
                      <li>Optimalkan query SQL untuk mempercepat eksekusi.</li>
                    </ul>
                  </li>
                  <li>Penggunaan Cache
                    <ul style={{ listStyleType: "circle", paddingLeft: "20px" }}>
                      <li>Implementasikan caching untuk menyimpan hasil query yang sering digunakan, menggunakan alat seperti Redis atau Memcached.</li>
                      <li>Gunakan cache sisi server atau API gateway untuk respons API.</li>
                    </ul>
                  </li>
                  <li>Optimisasi Kode
                    <ul style={{ listStyleType: "circle", paddingLeft: "20px" }}>
                      <li>Kurangi kompleksitas algoritma yang digunakan dalam pemrosesan.</li>
                      <li>Hindari operasi berat dalam permintaan API, seperti loop atau pengolahan data besar tanpa batching.</li>
                    </ul>
                  </li>
                </ul>
              </li>
              <li style={{ listStyleType: "disc", paddingLeft: "20px" }}>
                <strong>Tingkatkan Infrastruktur</strong>
                <ul style={{ listStyleType: "disc", paddingLeft: "20px" }}>
                  <li>Load Balancing
                    <ul style={{ listStyleType: "circle", paddingLeft: "20px" }}>
                      <li>Distribusikan lalu lintas secara merata ke beberapa server menggunakan load balancer seperti Nginx, HAProxy, atau AWS Elastic Load Balancing.</li>
                    </ul>
                  </li>
                  <li>Server yang Lebih Kuat
                    <ul style={{ listStyleType: "circle", paddingLeft: "20px" }}>
                      <li>Tingkatkan kapasitas CPU, RAM, atau penyimpanan pada server.</li>
                      <li>Gunakan SSD untuk penyimpanan lebih cepat dibandingkan HDD.</li>
                    </ul>
                  </li>
                  <li>Horizontal Scaling
                    <ul style={{ listStyleType: "circle", paddingLeft: "20px" }}>
                      <li>Tambahkan lebih banyak server untuk menangani beban yang lebih tinggi.</li>
                    </ul>
                  </li>
                  <li>Gunakan Content Delivery Network (CDN)
                    <ul style={{ listStyleType: "circle", paddingLeft: "20px" }}>
                      <li>CDN seperti Cloudflare atau AWS CloudFront dapat mempercepat pengiriman konten dengan mendistribusikannya dari lokasi terdekat dengan pengguna.</li>
                    </ul>
                  </li>
                </ul>
              </li>
              <li style={{ listStyleType: "disc", paddingLeft: "20px" }}>
                <strong>Kurangi Latensi Jaringan</strong>
                <ul style={{ listStyleType: "disc", paddingLeft: "20px" }}>
                  <li>Optimalkan Lokasi Server
                    <ul style={{ listStyleType: "circle", paddingLeft: "20px" }}>
                      <li>Pilih pusat data yang lebih dekat dengan pengguna Anda.</li>
                      <li>Jika target pengguna tersebar secara global, gunakan server regional atau multi-cloud deployment.</li>
                    </ul>
                  </li>
                  <li>Minimalkan Ukuran Respons
                    <ul style={{ listStyleType: "circle", paddingLeft: "20px" }}>
                      <li>Kompres data menggunakan Gzip atau Brotli.</li>
                      <li>Gunakan format data yang ringan seperti JSON atau Protobuf, dan hindari XML jika tidak diperlukan.</li>
                    </ul>
                  </li>
                  <li>Gunakan HTTP/2
                    <ul style={{ listStyleType: "circle", paddingLeft: "20px" }}>
                      <li>HTTP/2 memungkinkan pengiriman paralel yang lebih cepat daripada HTTP/1.1.</li>
                    </ul>
                  </li>
                </ul>
              </li>
              <li style={{ listStyleType: "disc", paddingLeft: "20px" }}>
                <strong>Optimisasi API</strong>
                <ul style={{ listStyleType: "disc", paddingLeft: "20px" }}>
                  <li>Pagination dan Batching
                    <ul style={{ listStyleType: "circle", paddingLeft: "20px" }}>
                      <li>Untuk data besar, gunakan pagination atau batching untuk membagi data ke dalam potongan kecil.</li>
                    </ul>
                  </li>
                  <li>Endpoint yang Spesifik
                    <ul style={{ listStyleType: "circle", paddingLeft: "20px" }}>
                      <li>Buat endpoint API yang hanya mengembalikan data yang benar-benar diperlukan oleh klien.</li>
                      <li>Hindari pengembalian data yang berlebihan.</li>
                    </ul>
                  </li>
                  <li>Gunakan Rate Limiting
                    <ul style={{ listStyleType: "circle", paddingLeft: "20px" }}>
                      <li>Batasi jumlah permintaan per klien untuk mencegah penyalahgunaan atau lonjakan lalu lintas.</li>
                    </ul>
                  </li>
                </ul>
              </li>
            </ol>
        </div>
        )


  
      

    },
    deviceDown: {
      title: "Device Down",
      definition: (
        <div>
          <ul style={{ listStyleType: "disc", paddingLeft: "20px" }}>
            <li>Power pada perangkat mengacu pada sumber daya listrik yang digunakan oleh perangkat untuk beroperasi. Perangkat membutuhkan daya listrik untuk menjalankan komponen internalnya seperti prosesor, memori, antena, dan port jaringan</li>
            <li>Jaringan dari ISP (Internet Service Provider) adalah infrastruktur yang disediakan oleh penyedia layanan internet untuk menghubungkan pelanggan ke internet global.</li>
          </ul>

        </div>
      ),
      analysis: (
        <div>
        <p>Mona belum mendapatkan data yang cukup untuk menganalisis kasus ini, tetapi Mona menganalisis bahwa kasus seperti ini sering terjadi karena Power Perangkat Mati atau Jaringan dari ISP Down.</p>
        <p>Power router yang mati dapat menyebabkan beberapa hal seperti:</p>
        <ol style={{ listStyleType: "decimal", paddingLeft: "20px" }}>
          <li style={{ paddingLeft: "20px" }}>
            <strong>Tidak Ada Akses Internet:</strong> Semua perangkat yang terhubung ke router, seperti komputer, ponsel, atau perangkat IoT (Internet of Things), tidak dapat mengakses internet.
          </li>
          <li style={{ paddingLeft: "20px" }}>
            <strong>Access Point atau Extender Mati:</strong> Jika router berfungsi sebagai penghubung untuk perangkat jaringan lain (seperti access point atau repeater), seluruh jaringan bisa terganggu.
          </li>
          <li style={{ paddingLeft: "20px" }}>
            <strong>Server Lokal Tidak Terhubung:</strong> Bagi bisnis, router mati dapat memutuskan koneksi ke server lokal atau layanan berbasis cloud.
          </li>
          <li style={{ paddingLeft: "20px" }}>
            <strong>Perangkat Smart Home Tidak Aktif:</strong> Perangkat seperti kamera keamanan, smart speaker, lampu pintar, atau kunci pintar yang terhubung ke router akan berhenti bekerja. Kamera keamanan atau sensor yang tergantung pada koneksi internet tidak dapat berfungsi untuk memantau lingkungan.
          </li>
          <li style={{ paddingLeft: "20px" }}>
            <strong>Gangguan pada Pengaturan Jaringan:</strong> Jika router mati tiba-tiba, beberapa pengaturan jaringan mungkin perlu dikonfigurasi ulang.
          </li>
          <li style={{ paddingLeft: "20px" }}>
            <strong>Potensi Korupsi Data:</strong> Pada kasus tertentu, router yang mati mendadak saat proses penting sedang berlangsung (misalnya, pembaruan firmware) bisa menyebabkan kerusakan data atau perangkat.
          </li>
        </ol>
        <p>Jaringan dari ISP yang Down dapat menyebabkan beberapa hal seperti:</p>
        <ol style={{ listStyleType: "decimal", paddingLeft: "20px" }}>
          <li style={{ paddingLeft: "20px" }}>
            <strong>Tidak Ada Akses Internet:</strong> Semua perangkat yang terhubung ke jaringan ISP tidak dapat mengakses internet, termasuk ponsel, komputer, dan perangkat IoT.
          </li>
          <li style={{ paddingLeft: "20px" }}>
            <strong>Smart Home Tidak Berfungsi:</strong> Perangkat pintar seperti termostat, smart lock, atau lampu pintar akan kehilangan fungsinya.
          </li>
          <li style={{ paddingLeft: "20px" }}>
            <strong>Layanan Cloud Tidak Dapat Diakses:</strong> Pengguna tidak dapat mengakses file, aplikasi, atau sistem yang disimpan di cloud.
          </li>
        </ol>
      </div>
        
      ),
      solution: (
        <div>
  <p>Jika power perangkat mati, maka Anda dapat melakukan beberapa langkah sebagai berikut:</p>
  <ol style={{ listStyleType: "decimal", paddingLeft: "20px" }}>
    <li style={{ paddingLeft: "20px" }}>
      <strong>Periksa Sumber Daya Listrik:</strong>
      <ul style={{ listStyleType: "disc", paddingLeft: "20px" }}>
        <li>Periksa apakah adaptor daya router terpasang dengan benar ke stopkontak dan port daya di router.</li>
        <li>Uji stopkontak dengan perangkat lain untuk memastikan bahwa stopkontak berfungsi dengan baik.</li>
        <li>Adaptor yang rusak bisa menjadi penyebab. Coba gunakan adaptor lain yang sesuai dengan spesifikasi router Anda.</li>
      </ul>
    </li>
    <li style={{ paddingLeft: "20px" }}>
      <strong>Cek Indikator Daya Router:</strong>
      <ul style={{ listStyleType: "disc", paddingLeft: "20px" }}>
        <li>Jika tidak ada lampu indikator yang menyala, kemungkinan besar masalah ada pada sumber daya atau perangkat keras router.</li>
        <li>Jika lampu berkedip atau redup, maka bisa menjadi tanda daya yang tidak stabil. Coba gunakan stabilizer atau UPS untuk memastikan aliran daya stabil.</li>
      </ul>
    </li>
    <li style={{ paddingLeft: "20px" }}>
      <strong>Reset Router (Jika Perangkat Menyala Sebentar):</strong>
      <ul style={{ listStyleType: "disc", paddingLeft: "20px" }}>
        <li>Matikan router, cabut kabel daya, tunggu sekitar 5-10 menit, lalu sambungkan kembali dan nyalakan.</li>
        <li>Jika router sempat menyala tetapi tidak berfungsi normal, gunakan tombol reset untuk mengembalikannya ke pengaturan pabrik. (Perhatikan bahwa ini akan menghapus semua pengaturan Anda.)</li>
      </ul>
    </li>
    <li style={{ paddingLeft: "20px" }}>
      <strong>Periksa Suhu dan Kebersihan Router:</strong>
      <ul style={{ listStyleType: "disc", paddingLeft: "20px" }}>
        <li>Router yang terlalu panas mungkin mati untuk melindungi komponen internalnya. Pastikan router memiliki ventilasi yang baik dan tidak ditempatkan di area tertutup.</li>
        <li>Jika ada debu yang menumpuk di lubang ventilasi, bersihkan menggunakan kain lembut atau udara bertekanan.</li>
      </ul>
    </li>
    <li style={{ paddingLeft: "20px" }}>
      <strong>Cek Komponen Hardware Router:</strong>
      <ul style={{ listStyleType: "disc", paddingLeft: "20px" }}>
        <li>Periksa apakah port daya di router longgar atau rusak. Jika rusak, perangkat mungkin perlu diperbaiki oleh teknisi.</li>
        <li>Periksa kabel daya apakah ada kerusakan fisik seperti sobekan atau bagian yang terkelupas.</li>
      </ul>
    </li>
    <li style={{ paddingLeft: "20px" }}>
      <strong>Bawa ke Pusat Layanan:</strong>
      <ul style={{ listStyleType: "disc", paddingLeft: "20px" }}>
        <li>Jika semua langkah di atas tidak berhasil, kemungkinan besar ada kerusakan internal pada perangkat keras router, seperti:</li>
        <ul style={{ listStyleType: "circle", paddingLeft: "20px" }}>
          <li>Kapasitor atau IC daya rusak.</li>
          <li>Sirkuit internal mengalami korsleting.</li>
        </ul>
        <li>Bawa router ke pusat layanan resmi atau teknisi yang berpengalaman untuk diperbaiki.</li>
      </ul>
    </li>
  </ol>
  <p>Jika jaringan dari ISP down, maka Anda dapat melakukan beberapa langkah sebagai berikut:</p>
  <ol style={{ listStyleType: "decimal", paddingLeft: "20px" }}>
    <li style={{ paddingLeft: "20px" }}>
      <strong>Periksa Status Koneksi:</strong>
      <ul style={{ listStyleType: "disc", paddingLeft: "20px" }}>
        <li>Cek Lampu Indikator Router/Modem. Lampu power, internet, dan Wi-Fi pada router dapat memberikan informasi tentang status jaringan. Lampu internet mati atau merah menunjukkan koneksi ISP bermasalah.</li>
        <li>Sambungkan perangkat langsung ke modem (tanpa router) menggunakan kabel LAN untuk memastikan bahwa masalah bukan berasal dari router.</li>
      </ul>
    </li>
    <li style={{ paddingLeft: "20px" }}>
      <strong>Periksa Penyebab Eksternal:</strong>
      <ul style={{ listStyleType: "disc", paddingLeft: "20px" }}>
        <li>Pemadaman listrik di area ISP dapat memengaruhi jaringan.</li>
        <li>Hujan deras atau badai dapat merusak infrastruktur ISP, seperti kabel atau antena.</li>
        <li>Hubungi layanan pelanggan ISP untuk mengetahui apakah ada gangguan di area Anda.</li>
      </ul>
    </li>
    <li style={{ paddingLeft: "20px" }}>
      <strong>Restart Perangkat:</strong>
      <ul style={{ listStyleType: "disc", paddingLeft: "20px" }}>
        <li>Matikan perangkat selama 1-2 menit, lalu nyalakan kembali.</li>
        <li>Pastikan perangkat seperti laptop atau ponsel yang terhubung telah diperbarui dan bebas dari cache jaringan yang bermasalah.</li>
      </ul>
    </li>
    <li style={{ paddingLeft: "20px" }}>
      <strong>Laporkan Masalah ke ISP:</strong>
      <ul style={{ listStyleType: "disc", paddingLeft: "20px" }}>
        <li>Hubungi Layanan Pelanggan ISP dan berikan informasi tentang lokasi Anda, masalah spesifik yang dialami (lampu indikator mati, lambat, atau putus total).</li>
        <li>Gunakan Aplikasi atau Situs ISP untuk memantau gangguan dan melaporkan masalah.</li>
        <li>Ketahui perkiraan waktu perbaikan agar Anda dapat merencanakan alternatif solusi lain seperti mencari backup jaringan dari ISP lain.</li>
      </ul>
    </li>
  </ol>
</div>
      ),

    },
    online: (
      <div>
        <p> Online adalah kondisi di mana perangkat hidup dan internet dapat diakses oleh user.</p>
        <p> Lakukan pemantauan secara berkala dan aktifkan fitur notifikasi agar layanan dapat berjalan dengan baik dan dapat segera dilakukan tindakan preventif jika terjadi insiden agar mengurangi downtime internet</p>
      </div>
    ),

    dyingGasp: (
      <div>
        <p>
          Dying Gasp adalah sinyal terakhir yang dikirimkan oleh ONT/modem
          sebelum mati. Untuk mengatasi masalah ini, lakukan langkah-langkah
          berikut:
        </p>
        <ol>
          <li>Pastikan adaptor sudah terpasang dengan kencang dan benar.</li>
          <li>Tekan tombol power pada ONT/modem.</li>
          <li>Tunggu hingga lampu power, internet, dan wifi ONT menyala.</li>
          <li>
            Koneksikan:
            <ul>
              <li>
                Apabila menggunakan LAN: pastikan kabel LAN sudah terpasang
                dengan benar dan kencang pada port LAN3 ONT.
              </li>
              <li>
                Apabila menggunakan Wifi: jika lampu wifi ONT mati, tekan tombol
                wifi hingga menyala.
              </li>
            </ul>
          </li>
        </ol>
      </div>
    ),
    los: (
      <div>
        <p>
          Loss of Signal (LOS) adalah kondisi di mana modem kehilangan sinyal.
          Hilangnya sinyal dapat terjadi karena masalah fiber maupun masalah
          kabel.
        </p>
        <p>
          Solusi status Internet LOS:
          <br />
          <br />
          Anda dapat mencoba beberapa cara berikut:
        </p>
        <ul>
          <li>Matikan modem, tunggu sebentar, kemudian nyalakan kembali</li>
          <li>
            Periksa semua kabel untuk memastikan terpasang dengan baik (kabel
            optik modem terpasang hingga terdengar bunyi 'klik').
          </li>
          <li>Pastikan modem IndiHome dalam keadaan menyala</li>
          <li>
            Lakukan reset modem (PENTING: Ini akan menghapus konfigurasi dan
            pengaturan modem. Pastikan Anda memiliki salinan informasi tersebut
            sebelum mereset)
          </li>
        </ul>
      </div>
    ),
    offline: (
      <div>
        <p>Offline adalah kondisi di mana pengguna mematikan modem internet.</p>
        <p>
          Solusi status Internet Offline:
          <br />
          <br />
          Anda dapat mencoba untuk:
        </p>
        <ul>
          <li>Nyalakan modem</li>
          <li>Restart modem</li>
        </ul>
      </div>
    ),
    sync: (
      <div>
        <p>Sync adalah kondisi internet sedang dalam proses sinkronisasi.</p>
      </div>
    ),
    unknown: (
      <div>
        <p>
          Unknown adalah kondisi internet mengalami kendala teknis sehingga data
          ukurnya tidak dapat diperoleh.
        </p>
      </div>
    ),
    suspend: (
      <div>
        <p>
          Silakan lakukan pembayaran untuk perangkat kamu yang tersuspend agar
          kamu bisa memonitor kembali perangkat kamu.
        </p>
      </div>
    ),
    test: (
      <div style={{ listStyleType: "disc", paddingLeft: "20px" }}>test</div>
    ),
  };

  const englishRecommendations = {
    latency: {
      title: "Latency",
      definition: (
        <div>
          <p>
            Latency is the time it takes for data to travel from its source to its destination, such as from a user's device (like a laptop) to a router or from a router to a server. Specifically, latency encompasses all delays or lags that occur during transmission.
          </p>
        </div>
      ),
      analysis: (
        <div>
          <p>Common impacts:</p>
          <ul style={{ listStyleType: "disc", paddingLeft: "20px" }}>
            <li><strong>Decreased Quality of Service:</strong> High latency causes interrupted communication, delays, or slow responses.</li>
          </ul>
          <br />
          <p>Impacts on other components:</p>
          <ul style={{ listStyleType: "disc", paddingLeft: "20px" }}>
            <li><strong>Device Capacity:</strong> High latency degrades device performance, slowing down services.</li>
            <li><strong>Traffic:</strong> Slows down data transfer, increases network congestion, and reduces transfer efficiency.</li>
          </ul>
        </div>
      ),
      solution: (
        <div>
          <p>
            Do the following recommendations to solve the Latency problem on your
            network:
          </p>
          <ol style={{ listStyleType: "decimal", paddingLeft: "20px" }}>
            <li>
              <strong>Optimize Router and Firmware</strong>
              <ul style={{ listStyleType: "disc", paddingLeft: "20px" }}>
                <li>
                  Restart the router to release the memory used and improve device
                  performance.
                </li>
                <li>
                  Schedule automatic restart if the router supports this feature.
                </li>
                <li>
                  Make sure the router always uses the latest firmware to fix bugs
                  and improve performance.
                </li>
                <li>
                  Visit the official website of the router manufacturer to
                  download the latest version.
                </li>
                <li>
                  If the existing configuration is already too complex or
                  problematic, perform a factory reset and reconfigure from
                  scratch.
                </li>
                <li>
                  Avoid unnecessary configurations to reduce the load on the
                  router.
                </li>
              </ul>
              <div></div>
            </li>
            <li>
              <strong>Optimize Wireless Network (Wi-Fi)</strong>
              <ul style={{ listStyleType: "disc", paddingLeft: "20px" }}>
                <li>
                  Use the 5 GHz frequency to reduce interference and get better
                  performance (for supported devices).

                </li>
                <li>
                  Use a Wi-Fi Analyzer to find less crowded channels and avoid
                  interference from neighboring networks.
                </li>
                <li>
                  Reduce the distance between the device and the router to get a
                  stronger signal and lower latency.
                </li>
                <li>
                  Avoid physical obstacles such as thick walls or metal that can
                  block the signal.
                </li>
                <li>
                  Use a Wi-Fi extender or mesh network if the coverage area is too
                  large to reduce latency and strengthen the signal in all areas.

                </li>
              </ul>
              <div></div>
            </li>
            <li>
              <strong>Traffic Management and Quality of Service (QoS)</strong>
              <ul style={{ listStyleType: "disc", paddingLeft: "20px" }}>
                <li>

                  Configure QoS on the router to prioritize important traffic such
                  as VoIP, video conferencing, and online gaming.
                </li>
                <li>
                  Set priorities for specific applications or devices that are
                  frequently used.
                </li>
                <li>
                  Disconnect unused devices to reduce the load on the router.

                </li>
                <li>
                  Set up a guest network to avoid interference with the main
                </li>
              </ul>
              <div></div>
            </li>
            <li>
              <strong>Replace or Upgrade Router</strong>
              <ul style={{ listStyleType: "disc", paddingLeft: "20px" }}>
                <li>

                  If the router is old or often overloaded, consider upgrading to a
                  new model with features:
                </li>
                <li>Wi-Fi 6 or Wi-Fi 6E for better performance.</li>
                <li>Dual-band or Tri-band to distribute traffic.</li>
                <li>
                  Higher CPU and RAM so the router can handle many devices without
                  latency.
                </li>
              </ul>
              <div></div>
            </li>
            <li>
              <strong>Check Cables and Physical Connections</strong>
              <ul style={{ listStyleType: "disc", paddingLeft: "20px" }}>
                <li>
                  Use Cat6 or Cat7 Ethernet cables to ensure faster and more stable
                </li>
                <li>

                  Check the cables for damage or loose connections.

                </li>
                <li>
                  Make sure there are no loops (cycles) in the network that can
                  cause increased traffic and latency.
                </li>
                <li>
                  Use Spanning Tree Protocol (STP) if there are multiple switches
                  in the network.
                </li>
              </ul>
              <div></div>
            </li>
            <li>
              <strong>Monitoring and Diagnostics</strong>
              <ul style={{ listStyleType: "disc", paddingLeft: "20px" }}>

                <li>
                  Use Network Monitoring services to monitor router and device
                  performance in real-time.
                </li>
                <li>
                  Identify devices or applications that consume excessive bandwidth
                  and cause latency.
                </li>
                <li>
                  Run a ping to the ISP gateway or external server to ensure the
                  problem is not from the ISP.
                </li>
                <li>
                  Contact the ISP if high latency is caused by an external network.
                </li>

              </ul>
              <div></div>
            </li>
            <li>
              <strong>Load Balancing or Backup Link Implementation</strong>
              <ul style={{ listStyleType: "disc", paddingLeft: "20px" }}>
                <li>
                  Use a load balancer to distribute traffic evenly across multiple
                  links.
                </li>
                <li>
                  Use a backup link if there is an overload or problem with the
                  main connection path.
                </li>
              </ul>
            </li>
          </ol>
        </div>
      )
    },
    packetLoss: {
      title: "Packet Loss",
      definition: (
        <div>
          <p>Packet Loss refers to the condition where data is lost during transmission, resulting in incomplete reception at the destination.</p>
        </div>
      ),
      analysis: (
        <div>
          <p>Common impacts:</p>
          <ul style={{ listStyleType: "disc", paddingLeft: "20px" }}>
            <li><strong>Reduced Quality of Service:</strong> Causes choppy audio and blurry or frozen video.</li>
            <li><strong>Data Performance:</strong> Data loss can disrupt real-time applications and degrade user experience.</li>
          </ul>

          <br />
          <p>Impact on other components:</p>
          <ul style={{ listStyleType: "disc", paddingLeft: "20px" }}>
            <li><strong>Device Capacity:</strong> Devices may become unstable, leading to decreased performance and suboptimal application or service functionality.</li>
            <li><strong>Traffic:</strong> Packet loss increases congestion and slows down data transmission, reducing network efficiency.</li>
          </ul>
        </div>
      ),
      solution: (
        <div>

          <p>
            Follow these recommended steps to address packet loss issues in your network:
          </p>
          <ol style={{ listStyleType: "decimal", paddingLeft: "20px" }}>
            <li>
              <strong>Reduce Network Load: </strong>
              Limit the number of active devices and stop high-bandwidth applications such as downloads or streaming when not needed.
            </li>
            <li>
              <strong>Use a Wired (Ethernet) Connection: </strong>
              Ethernet connections are more stable than Wi-Fi and reduce the risk of interference.
            </li>
            <li>
              <strong>Replace or Repair Network Cables: </strong>
              Use high-quality cables like Cat6 or Cat7, and check for loose or damaged cables.
            </li>
            <li>
              <strong>Update Firmware and Hardware: </strong>
              Update the firmware of your router or switch to fix bugs and improve performance.
            </li>
            <li>
              <strong>Enable QoS (Quality of Service): </strong>
              QoS can prioritize critical traffic (such as VoIP and video calls) and prevent packet loss during high network usage.
            </li>
            <li>
              <strong>Minimize Wi-Fi Interference: </strong>
              Switch to the 5 GHz frequency to reduce interference and choose a less crowded channel.
            </li>
            <li>
              <strong>Contact Your ISP: </strong>
              If packet loss occurs outside your local network, report the issue to your Internet Service Provider for troubleshooting or resolution.
            </li>
          </ol>
        </div>
      )
    },
    jitter: {
      title: "Jitter",
      definition: (
        <div>
          <p>
            Jitter refers to the variation in delay experienced during the transmission and reception of data.
          </p>
        </div>
      ),
      analysis: (
        <div>
          <p>Common impacts:</p>
          <ul style={{ listStyleType: "disc", paddingLeft: "20px" }}>
            <li>
              <strong>Reduced Quality of Service:</strong>
              <ol style={{ listStyleType: "circle", paddingLeft: "20px" }}>
                <li><strong>Voice Calls:</strong> Audio becomes choppy or unclear.</li>
                <li><strong>Video Conferencing:</strong> Video may become out of sync with audio or experience interruptions.</li>
              </ol>
            </li>
            <li>
              <strong>Connection Stability Issues:</strong> Network instability worsens user experience, especially for applications requiring consistent data transfer.
            </li>
          </ul>
          <br />
          <p>Impact on other components:</p>
          <ul style={{ listStyleType: "disc", paddingLeft: "20px" }}>
            <li>
              <strong>Device Capacity:</strong> Devices work harder due to delayed or lost data, reducing overall performance.
            </li>
            <li>
              <strong>Traffic:</strong> High jitter can worsen network congestion, increase latency, and reduce data transfer speed, particularly in high-traffic conditions.
            </li>
          </ul>
        </div>
      ),
      solution: (
        <div>
          <p>
            Jitter is the variation in data packet delivery time on the network.
            Jitter indicates inconsistency in the interval between packets when
            data is sent from source to destination. Some data packets may arrive
            faster or slower than they should, causing instability in the
            connection.
          </p>
          <p>
            Do the following recommendations to solve the Jitter problem on your
            network:
          </p>
          <ol style={{ listStyleType: "decimal", paddingLeft: "20px" }}>
            <li>
              <strong>Activate QoS (Quality of Service): </strong>
              Configure QoS on the router to prioritize real-time applications
              such as VoIP and video conferencing, so that important packets are
              not delayed.
            </li>
            <li>
              <strong>Reduce Network Load: </strong>
              Limit the number of connected devices or stop applications that use
              large bandwidth, such as large downloads or video streaming.

            </li>
            <li>
              <strong>Use Ethernet Cable Connection: </strong>
              Ethernet cables are more stable and have lower latency and jitter
              than Wi-Fi.
            </li>
            <li>

              <strong>Optimize Router and Switch: </strong>
              Use high-performance routers or switches and make sure the firmware
              is always updated to improve packet processing efficiency.

            </li>
            <li>
              <strong>Minimize Wi-Fi Interference: </strong>
              Switch to the 5 GHz frequency and choose a less crowded Wi-Fi
              channel to avoid interference.
            </li>
            <li>
              <strong>Monitoring and Network Diagnostics: </strong>
              Monitor the network regularly using tools like PRTG Network Monitor
              to detect jitter and fix it before it has a significant impact.

            </li>
          </ol>
        </div>
      )
    },
    cpu: {
      title: "CPU",
      definition: (
        <div>
          <ul style={{ listStyleType: "disc", paddingLeft: "20px" }}>
            <li>
              The CPU (Central Processing Unit) is the primary component responsible for executing instructions and processing tasks to operate network devices such as routers, switches, or servers.
            </li>
            <li>
              A nearly full CPU occurs when it reaches a warning state (usage {'>'} 50%) or a critical state (usage {'>'} 80%), indicating the device is approaching its capacity limit, which can impair or disrupt its performance.
            </li>
          </ul>
        </div>
      ),
      analysis: (
        <div>
          <p>If the CPU capacity is nearly full:</p>

          <ul style={{ listStyleType: "disc", paddingLeft: "20px" }}>
            <li><strong>Decreased Performance:</strong> The device becomes slow as the CPU struggles to process data.</li>
            <li><strong>Service Disruption:</strong> Network operations are impacted, causing delays or downtime.</li>
            <li><strong>Potential Crash:</strong> High loads can cause the device to fail or stop functioning.</li>
            <li><strong>System-wide Effects:</strong> Other devices in the network may be affected, worsening overall performance.</li>
          </ul>
          <br />
          <p>Impact on other components:</p>
          <ul style={{ listStyleType: "disc", paddingLeft: "20px" }}>
            <li>
              <strong>Quality of Service (QoS):</strong> Reduced CPU performance affects the quality of network services.
            </li>
            <li>
              <strong>Traffic:</strong> Data processing slows down, leading to high latency and potential packet loss.
            </li>
          </ul>
        </div>
      ),
      solution: (
        <div>
          <p>

            Do the following recommendations to solve the CPU Device problem:
          </p>
          <ol style={{ listStyleType: "decimal", paddingLeft: "20px" }}>
            <li>Redistribute the workload to other less busy nodes.</li>
            <li>
              Optimize running applications to reduce CPU usage.
            </li>
            <li>
              Increase CPU capacity by adding additional processors or cores.
            </li>
            <li>
              Disable or stop unnecessary or excessive applications.
            </li>
            <li>
              Use a load balancer to manage and distribute traffic more efficiently.
            </li>
          </ol>
        </div>
      )
    },
    cpuUnderutilized: {
      title: "CPU Underutilized",
      definition: (
        <div>
          <ul style={{ listStyleType: "disc", paddingLeft: "20px" }}>
            <li>
              The CPU (Central Processing Unit) is the primary component responsible for executing instructions and processes to operate network devices such as routers, switches, or servers.
            </li>
            <li>
              CPU underutilization occurs when CPU usage is {"<"} 30%, indicating that the device is not being optimally utilized, resulting in wasted capacity.
            </li>
          </ul>
        </div>
      ),
      analysis: (
        <div>
          <p>If the CPU is underutilized:</p>
          <ul style={{ listStyleType: "disc", paddingLeft: "20px" }}>
            <li><strong>Low Efficiency:</strong> Device capacity is wasted.</li>
            <li><strong>Excessive Power Consumption:</strong> The device remains active without delivering optimal performance.</li>
            <li><strong>High Operational Costs:</strong> The device's usage does not match its full potential.</li>
          </ul>
          <br />
          <p>Impact on other components:</p>
          <ul style={{ listStyleType: "disc", paddingLeft: "20px" }}>
            <li>
              <strong>Quality of Service (QoS):</strong> Network services are not maximized because the device is not working at its optimal level.
            </li>
            <li>
              <strong>Traffic:</strong> Data flow may be hindered due to inefficient resource management.
            </li>
          </ul>
        </div>
      ),
      solution: (
        <div>
          <p>
            Here are the steps you can take to address underutilized or underloaded
            CPU:
          </p>
          <ol style={{ listStyleType: "decimal", paddingLeft: "20px" }}>
            <li>

              <strong>Low Network Traffic</strong>
              <ul style={{ listStyleType: "disc", paddingLeft: "20px" }}>
                <li>

                  If network traffic is not too high, the router's CPU may not need
                  to work hard. This usually happens during off-peak hours or when
                  the network is not heavily used.
                </li>
                <li>
                  Solution: Monitor the performance of the device during peak
                  traffic hours to see if the CPU is fully utilized. Use traffic
                  simulation tools to test the performance of the device under
                </li>
              </ul>
              <div></div>
            </li>
            <li>
              <strong>
                Router Specifications Too High for Needs
              </strong>
              <ul style={{ listStyleType: "disc", paddingLeft: "20px" }}>
                <li>

                  A router with a powerful CPU for the current network needs can
                  cause underutilization, especially if only used for basic routing
                  without additional features.
                </li>
                <li>
                  Solution: Make sure the router specifications are suitable for
                  the network needs. If the router supports additional features
                  such as firewall or VPN, consider enabling these features to
                  increase CPU utilization.
                </li>
              </ul>
              <div></div>
            </li>
            <li>
              <strong>Less Optimal Configuration</strong>
              <ul style={{ listStyleType: "disc", paddingLeft: "20px" }}>
                <li>
                  Some configurations can cause traffic not to be evenly distributed
                  to all available CPU cores, resulting in low CPU utilization.

                </li>
                <li>
                  Solution: Check the load balancing or load distribution
                  configuration, especially if the router has a multi-core CPU.
                  Ensure that heavy tasks such as NAT or VPN are distributed
                  properly to all cores.
                </li>
              </ul>
              <div></div>
            </li>
            <li>
              <strong>Bottleneck on Other Components</strong>
              <ul style={{ listStyleType: "disc", paddingLeft: "20px" }}>
                <li>
                  Underutilized can also occur if there is a bottleneck or
                  obstruction in other components such as memory or network ports,
                  which limits overall performance even though the CPU is not
                  overloaded.
                </li>
                <li>
                  Solution: Check memory usage and network port capacity to ensure
                  there are no bottlenecks. If necessary, upgrade or adjust settings
                  so that all components can work optimally.
                </li>
              </ul>
              <div></div>
            </li>
            <li>
              <strong>Optimize Router Feature Usage</strong>
              <ul style={{ listStyleType: "disc", paddingLeft: "20px" }}>
                <li>
                  If the router has additional features (such as IDS/IPS, advanced
                  firewall, QoS), enabling these features can increase CPU usage.

                </li>
                <li>
                  Solution: Enable additional features as needed, such as packet
                  inspection, traffic control, or security features to maximize
                  router usage.
                </li>
              </ul>
              <div></div>
            </li>
          </ol>
        </div>
      )
    },
    memory: {
      title: "Memory",
      definition: (
        <div>
          <ul style={{ listStyleType: "disc", paddingLeft: "20px" }}>
            <li>RAM (Random Access Memory) is temporary memory used by network devices to quickly store and access data.</li>
            <li>Memory nearing full capacity occurs when in a warning state (usage {'>'} 50%) and a critical state (usage {'>'} 80%), indicating that the device is approaching its capacity limit, which can disrupt or hinder its performance.</li>
          </ul>
        </div>
      ),
      analysis: (
        <div>
          <p>If the memory capacity is nearly full:</p>
          <ul style={{ listStyleType: "disc", paddingLeft: "20px" }}>
            <li><strong>Decreased Performance:</strong> Data processing becomes slower, affecting the device's responsiveness.</li>
            <li><strong>Service Disruption:</strong> Network services are hindered, causing delays or downtime.</li>
            <li><strong>Risk of Crash:</strong> Excessive memory usage can cause the device to become unstable or fail to operate.</li>
            <li><strong>Systemic Effects:</strong> Other devices in the network may be affected, worsening overall performance.</li>
          </ul>
          <br />
          <p>Impact on other components:</p>
          <ul style={{ listStyleType: "disc", paddingLeft: "20px" }}>
            <li><strong>Quality of Service (QoS):</strong> Memory performance degradation affects network service quality.</li>
            <li><strong>Traffic:</strong> Data processing is hindered, increasing latency or packet loss.</li>
          </ul>
        </div>
      ),
      solution: (
        <div>
          <p>
            Do the following recommendations to solve the Memory Device problem:
          </p>
          <ol style={{ listStyleType: "decimal", paddingLeft: "20px" }}>

            <li> Increase the Memory capacity on the affected node.</li>
            <li>
              Identify and optimize applications that use a lot of Memory.
            </li>
            <li>Stop unnecessary applications to free up Memory.</li>
            <li>
              Use more efficient paging or swap techniques if possible.
            </li>
            <li>
              Distribute applications to other nodes with lower Memory usage.
            </li>
          </ol>
        </div>
      )
    },
    memoryUnderutilized: {
      title: "Memory Underutilized",
      definition: (
        <div>
          <ul style={{ listStyleType: "disc", paddingLeft: "20px" }}>
            <li>RAM (Random Access Memory) is temporary memory used by network devices to quickly store and access data.</li>
            <li>Memory Underutilization occurs when memory usage is {'<'} 30%, indicating that the device is not being utilized optimally, resulting in wasted capacity.</li>
          </ul>
        </div>
      ),
      analysis: (
        <div>
          <p>If the memory capacity is underutilized:</p>
          <ul style={{ listStyleType: "disc", paddingLeft: "20px" }}>
            <li><strong>Low Efficiency:</strong> The device's capacity is not being used optimally.</li>
            <li><strong>Inefficient Power Consumption:</strong> The device remains active despite resources not being used effectively.</li>
            <li><strong>High Operational Costs:</strong> The device is not being used according to its actual needs.</li>
          </ul>
          <br />
          <p>Impact on other components:</p>
          <ul style={{ listStyleType: "disc", paddingLeft: "20px" }}>
            <li><strong>Quality of Service (QoS):</strong> Network services are not maximized because the memory is not working optimally.</li>
            <li><strong>Traffic:</strong> Data processing is slow due to inefficient resource management.</li>
          </ul>
        </div>
      ),
      solution: (
        <div>

          <p>
            Here are the steps you can take to address underutilized or underloaded
            RAM:
          </p>
          <ol style={{ listStyleType: "decimal", paddingLeft: "20px" }}>
            <li>

              <strong>Device Not Configured for Maximum Load</strong>

              <ul style={{ listStyleType: "disc", paddingLeft: "20px" }}>
                <li>
                  If the device only performs basic functions (such as simple
                  routing or NAT) without additional features such as firewall, QoS,
                  or VPN. RAM may not be used optimally.
                </li>
                <li>
                  Solution: Enable additional relevant features, such as packet
                  inspection (DPI), Quality of Service (QoS), or traffic logging.
                  Adjust the configuration to utilize features that support network
                  stability and security.
                </li>
              </ul>
              <div></div>
            </li>
            <li>
              <strong>⁠Device Specifications Too High for Needs</strong>
              <ul style={{ listStyleType: "disc", paddingLeft: "20px" }}>
                <li>
                  A router with large RAM may be designed to handle a much higher
                  network load than you currently have.
                </li>
                <li>
                  Solution: Evaluate network needs. If your network needs are small,
                  you may be able to use a device with lower specifications. However,
                  if there are plans to expand the network, no special action is
                  needed, as extra RAM will be beneficial in the future.

                </li>
              </ul>
              <div></div>
            </li>
            <li>
              <strong>⁠Light Network Traffic</strong>
              <ul style={{ listStyleType: "disc", paddingLeft: "20px" }}>
                <li>
                  If your network is not too busy or there are not many devices
                  connected, the device may not be able to use RAM to the maximum.

                </li>
                <li>
                  Solution: Test the device's performance under heavier traffic.
                  Simulate traffic using tools like iPerf or trafgen to see how
                  memory is used under heavy conditions.
                </li>
              </ul>
              <div></div>
            </li>
            <li>
              <strong>⁠Cache Not Utilized Optimally</strong>
              <ul style={{ listStyleType: "disc", paddingLeft: "20px" }}>
                <li>
                  Router RAM is often used for caching (such as ARP cache, DNS cache,
                  or buffering). If the cache is small, RAM is not optimally used.

                </li>
                <li>
                  Solution: Increase the size of the DNS, ARP, or packet buffer cache
                  if the device supports these settings. If you use features like
                  Content Filtering or Proxy, adjust them to use memory more
                  efficiently.
                </li>
              </ul>
              <div></div>
            </li>
            <li>
              <strong>Logging Not Enabled</strong>
              <ul style={{ listStyleType: "disc", paddingLeft: "20px" }}>
                <li>

                  Logging network activity uses RAM. If logging is turned off, RAM
                  will remain empty.
                </li>
                <li>
                  Solution: Enable logging on the router for network monitoring.
                  Save logs to local storage for analysis or troubleshooting in the
                  future. Note: Be careful not to make logs too large to overload
                </li>
              </ul>
              <div></div>
            </li>
            <li>
              <strong>⁠Potential Bottleneck on Other Components</strong>
              <ul style={{ listStyleType: "disc", paddingLeft: "20px" }}>
                <li>

                  If other components such as CPU or network port become a bottleneck,
                  the router cannot use RAM optimally.
                </li>
                <li>
                  Solution: Analyze the performance of the device as a whole. If the
                  CPU or port bandwidth is too low, consider upgrading the router or
                  optimizing the configuration.
                </li>
              </ul>
              <div></div>
            </li>
          </ol>
        </div>
      )
    },
    storage: {
      title: "Storage",
      definition: (
        <div>
          <ul style={{ listStyleType: "disc", paddingLeft: "20px" }}>
            <li>Storage is the capacity to store data on network devices, such as HDD or SSD, which hold data, configurations, and logs essential for the device's operation.</li>
            <li>Storage is almost full when it reaches a warning status (usage {'>'} 50%) and critical status (usage {'>'} 80%), indicating the device is approaching its capacity limit, which can affect its performance.</li>
          </ul>
        </div>
      ),
      analysis: (
        <div>
          <p>If storage capacity is almost full:</p>
          <ul style={{ listStyleType: "disc", paddingLeft: "20px" }}>
            <li><strong>Performance Degradation:</strong> Full storage can slow down data processing.</li>
            <li><strong>Operational Disruption:</strong> New data cannot be stored, causing system or application failure.</li>
            <li><strong>Potential Data Loss:</strong> The risk of losing important data increases as storage capacity is insufficient.</li>
          </ul>
          <ul style={{ listStyleType: "disc", paddingLeft: "20px" }}>
            <li><strong>Quality of Service (QoS):</strong> Network performance degrades as data processing is hindered.</li>
            <li><strong>Traffic:</strong> Latency increases, and packet loss may occur due to storage capacity limitations.</li>
          </ul>
        </div>
      ),
      solution: (
        <div>
          <p>
            Do the following recommendations to solve the Storage Device problem:
          </p>
          <ol style={{ listStyleType: "decimal", paddingLeft: "20px" }}>
            <li>Remove or archive unnecessary data to free up storage space.</li>
            <li>Optimize storage usage by compressing data if possible.</li>
            <li>Move rarely accessed data to slower or cheaper storage.</li>
            <li>Increase storage capacity by adding new drives or upgrading existing drives.</li>
            <li>Implement stricter data retention policies to limit the amount of data stored.</li>
          </ol>
        </div>
      )
    },
    storageUnderutilized: {
      title: "Storage Underutilized",
      definition: (
        <div>
          <ul style={{ listStyleType: "disc", paddingLeft: "20px" }}>
            <li>Storage is the capacity to store data on network devices, such as HDD or SSD, which hold data, configurations, and logs essential for the device's operation.</li>
            <li>Storage underutilization occurs when storage usage is {'<'} 30%, indicating that the device is not being fully utilized, resulting in wasted capacity.</li>
          </ul>
        </div>
      ),
      analysis: (
        <div>
          <p>If storage is underutilized:</p>
          <ul style={{ listStyleType: "disc", paddingLeft: "20px" }}>
            <li><strong>Cost Inefficiency:</strong> Unused storage wastes costs without providing significant benefits.</li>
            <li><strong>Potential Overprovisioning:</strong> Excess capacity creates wasted resources.</li>
          </ul>
          <br />
          <p>Impact on other components:</p>
          <ul style={{ listStyleType: "disc", paddingLeft: "20px" }}>
            <li><strong>Quality of Service (QoS):</strong> Underutilized storage could be used to accelerate services and enhance network quality.</li>
            <li><strong>Traffic:</strong> Available storage capacity can be redirected to support high traffic demands.</li>
          </ul>
        </div>
      ),
      solution: (
        <div>

          <p>
            Here are the steps you can take to address underutilized or underloaded
            Storage:
          </p>
          <ol style={{ listStyleType: "decimal", paddingLeft: "20px" }}>
            <li>
              <strong>Basic Router Function</strong>
              <ul style={{ listStyleType: "disc", paddingLeft: "20px" }}>
                <li>

                  Routers that are only used for basic routing and NAT usually do
                  not require much storage. Most of the storage space will be used
                  for the operating system, minimal logs, or configuration.

                </li>
                <li>

                  Solution: If the basic functions are sufficient, there is no need
                  to worry. However, you can consider additional features such as
                  detailed logging or caching to optimize your storage.
                </li>
              </ul>
              <div></div>
            </li>
            <li>
              <strong>Excessive Storage Capacity</strong>
              <ul style={{ listStyleType: "disc", paddingLeft: "20px" }}>
                <li>
                  Modern routers are often equipped with large storage to support
                  additional features such as logging, caching, or additional
                  applications. If these features are not activated, storage will
                  appear underutilized.
                </li>
                <li>
                  Solution: Evaluate whether there are features that can be
                  activated, such as traffic logging, DNS caching, or QoS
                  monitoring. Consider using storage for backup configuration files
                  or firmware.
                </li>
              </ul>
              <div></div>
            </li>
            <li>
              <strong>Logging Not Enabled</strong>
              <ul style={{ listStyleType: "disc", paddingLeft: "20px" }}>
                <li>
                  Routers use storage to store network activity logs, such as
                  traffic, security events, or system configuration. If logging is
                  turned off or directed to an external server, storage will be
                  empty.
                </li>
                <li>
                  Solution: Enable logging on the router for network monitoring.
                  Save logs to local storage for analysis or troubleshooting in the
                  future. Note: Be careful not to make logs too large so as not to
                  overload storage.

                </li>
              </ul>
              <div></div>
            </li>
            <li>
              <strong>Not Using Caching Features</strong>
              <ul style={{ listStyleType: "disc", paddingLeft: "20px" }}>
                <li>
                  Some routers support caching for DNS, ARP, or other data to
                  improve performance. If caching is turned off, storage will be
                  underutilized.
                </li>
                <li>
                  Solution: Enable caching features if the router supports it,
                  especially for networks with many DNS requests or repeated
                  traffic.
                </li>
              </ul>
              <div></div>
            </li>
            <li>
              <strong>No Use of Firmware or Extra Add-Ons</strong>
              <ul style={{ listStyleType: "disc", paddingLeft: "20px" }}>
                <li>

                  Some routers support the installation of additional applications
                  such as VPN servers, IDS/IPS, or monitoring. If additional
                  applications are not used, storage will be empty.

                </li>
                <li>
                  Solution: Install additional applications if possible and relevant
                  to your network needs. Update firmware regularly, and save several
                  backup versions in storage for rollback if problems occur.

                </li>
              </ul>
              <div></div>
            </li>
            <li>
              <strong>Backup or Configuration Capacity</strong>
              <ul style={{ listStyleType: "disc", paddingLeft: "20px" }}>
                <li>
                  Storage can be used to store configuration files, system backups,
                  or network automation scripts.
                </li>
                <li>
                  Solution: Store important configuration backups in router storage.
                  Create automation scripts for administrative tasks (if the router
                  supports scripting).
                </li>
              </ul>
              <div></div>
            </li>
            <li>
              <strong>Using Storage for File Sharing</strong>
              <ul style={{ listStyleType: "disc", paddingLeft: "20px" }}>
                <li>
                  Some routers with USB storage or network-attached storage (NAS)
                  features can be used to share files on the local network.

                </li>
                <li>

                  Solution: If your router supports this feature, use storage to share
                  documents, media, or important files on the network.
                </li>
              </ul>
              <div></div>
            </li>
          </ol>
        </div>
      )
    },
    traffic: {
      title: "Traffic",
      definition: (
        <div>
          <ul style={{ listStyleType: "disc", paddingLeft: "20px" }}>
            <li>Traffic In refers to data received by a network or device from external sources. For example, downloading files, streaming videos, or receiving emails.</li>
            <li>Traffic Out refers to data sent from a network or device to external sources. Examples include uploading files, sending emails, or accessing web pages.</li>
          </ul>
        </div>
      ),
      analysis: (
        <div>
          <p>Common impacts:</p>
          <ul style={{ listStyleType: "disc", paddingLeft: "20px" }}>
            <li><strong>Decreased Service Quality:</strong> Traffic issues can slow down data transmission, increase latency, and degrade service quality.</li>
          </ul>
          <br />
          <p>Impacts on other components:</p>
          <ul style={{ listStyleType: "disc", paddingLeft: "20px" }}>
            <li><strong>Device Capacity:</strong> Traffic disruptions can slow down data processing, reducing device performance and network efficiency.</li>
            <li><strong>QoS (Quality of Service):</strong> Reduced traffic flow can degrade service quality, increase latency, and lower real-time application performance.</li>
          </ul>
        </div>
      ),
      solution: (
        <div>
          <p>Here are the steps you can take to address Traffic issues:</p>
          <ol style={{ listStyleType: "decimal", paddingLeft: "20px" }}>
            <li style={{ listStyleType: "disc", paddingLeft: "20px" }}>
              <strong>Identify the Cause of High Traffic</strong>
              <ul style={{ listStyleType: "disc", paddingLeft: "20px" }}>
                <li>
                  Use Monitoring Tools: Utilize software or router features to monitor network activity (e.g., devices and applications consuming the most data).
                </li>
                <li>
                  Check Devices on the Network: Ensure that devices connected to the router belong to authorized users. Check for suspicious devices.
                </li>
              </ul>
            </li>
            <li style={{ listStyleType: "disc", paddingLeft: "20px" }}>
              <strong>Optimize and Control Bandwidth</strong>
              <ul style={{ listStyleType: "disc", paddingLeft: "20px" }}>
                <li>
                  Prioritize Essential Applications: Enable Quality of Service (QoS) features on the router to prioritize critical applications like video conferencing or online work.
                </li>
                <li>
                  Limit Bandwidth for Heavy Applications: Block or restrict bandwidth usage for unnecessary applications or services.
                </li>
                <li>
                  Block Unknown Devices: If unfamiliar devices are detected, block them through the router settings.
                </li>
              </ul>
            </li>
            <li style={{ listStyleType: "disc", paddingLeft: "20px" }}>
              <strong>Secure Your Network</strong>
              <ul style={{ listStyleType: "disc", paddingLeft: "20px" }}>
                <li>
                  Change Wi-Fi Passwords: If high traffic is caused by unauthorized users, update your password and use stronger encryption protocols (e.g., WPA3).
                </li>
                <li>
                  Update Router Firmware: Ensure your router runs the latest firmware to protect against security vulnerabilities.
                </li>
                <li>
                  Enable Firewall: Use the router’s firewall features to block suspicious traffic.
                </li>
              </ul>
            </li>
            <li style={{ listStyleType: "disc", paddingLeft: "20px" }}>
              <strong>Prevent Network Attacks</strong>
              <ul style={{ listStyleType: "disc", paddingLeft: "20px" }}>
                <li>
                  Detect DDoS Attacks: High inbound traffic could indicate a Distributed Denial of Service (DDoS) attack. Use anti-DDoS services or contact your ISP for help.
                </li>
                <li>
                  Block Suspicious IPs: If suspicious traffic from certain IP addresses is detected, use the router settings to block them.
                </li>
              </ul>
            </li>
            <li style={{ listStyleType: "disc", paddingLeft: "20px" }}>
              <strong>Consult Your ISP</strong>
              <ul style={{ listStyleType: "disc", paddingLeft: "20px" }}>
                <li>
                  ISP Consultation: If traffic remains high despite these steps, contact your Internet Service Provider to check for anomalies on their end.
                </li>
                <li>
                  Upgrade Internet Package: If your network usage has increased reasonably, consider upgrading your bandwidth package.
                </li>
              </ul>
            </li>
          </ol>
        </div>
      )
    },
    
    process : {
      title: "Process",
      definition: (
        <p> lorem ipsum</p>
      ),
      analysis: (
        <p> lorem ipsum</p>
      ),
      solution: (
        <p> lorem ipsum</p>
      )
    },
    container: {
      title: "Container",
      definition: (
        <p> lorem ipsum</p>
      ),
      analysis: (
        <p> lorem ipsum</p>
      ),
      solution: (
        <p> lorem ipsum</p>
      )
    },
    cpuServer: {
      title: "CPU",
      definition: (
        <div>
          <ul style={{ listStyleType: "disc", paddingLeft: "20px" }}>
            <li>
              The CPU (Central Processing Unit) is the primary component responsible for executing instructions and processing tasks to operate network devices such as routers, switches, or servers.
            </li>
            <li>
              A nearly full CPU occurs when it reaches a warning state (usage {'>'} 50%) or a critical state (usage {'>'} 80%), indicating the device is approaching its capacity limit, which can impair or disrupt its performance.
            </li>
          </ul>
        </div>
      ),
      analysis: (
        <div>
          <p>If the CPU capacity is nearly full:</p>

          <ul style={{ listStyleType: "disc", paddingLeft: "20px" }}>
            <li><strong>Decreased Performance:</strong> The device becomes slow as the CPU struggles to process data.</li>
            <li><strong>Service Disruption:</strong> Network operations are impacted, causing delays or downtime.</li>
            <li><strong>Potential Crash:</strong> High loads can cause the device to fail or stop functioning.</li>
            <li><strong>System-wide Effects:</strong> Other devices in the network may be affected, worsening overall performance.</li>
          </ul>
          <br />
          
        </div>
      ),
      solution: (
        <div>
          <p>

            Do the following recommendations to solve the CPU Device problem:
          </p>
          <ol style={{ listStyleType: "decimal", paddingLeft: "20px" }}>
            <li>Redistribute the workload to other less busy nodes.</li>
            <li>
              Optimize running applications to reduce CPU usage.
            </li>
            <li>
              Increase CPU capacity by adding additional processors or cores.
            </li>
            <li>
              Disable or stop unnecessary or excessive applications.
            </li>
            <li>
              Use a load balancer to manage and distribute traffic more efficiently.
            </li>
          </ol>
        </div>
      )
    },
    cpuUnderutilizedServer: {
      title: "CPU Underutilized",
      definition: (
        <div>
          <ul style={{ listStyleType: "disc", paddingLeft: "20px" }}>
            <li>
              The CPU (Central Processing Unit) is the primary component responsible for executing instructions and processes to operate network devices such as routers, switches, or servers.
            </li>
            <li>
              CPU underutilization occurs when CPU usage is {"<"} 30%, indicating that the device is not being optimally utilized, resulting in wasted capacity.
            </li>
          </ul>
        </div>
      ),
      analysis: (
        <div>
          <p>If the CPU is underutilized:</p>
          <ul style={{ listStyleType: "disc", paddingLeft: "20px" }}>
            <li><strong>Low Efficiency:</strong> Device capacity is wasted.</li>
            <li><strong>Excessive Power Consumption:</strong> The device remains active without delivering optimal performance.</li>
            <li><strong>High Operational Costs:</strong> The device's usage does not match its full potential.</li>
          </ul>
          <br />
          
        </div>
      ),
      solution: (
        <div>
          <p>
            Here are the steps you can take to address underutilized or underloaded
            CPU:
          </p>
          <ol style={{ listStyleType: "decimal", paddingLeft: "20px" }}>
            <li>

              <strong>Low Network Traffic</strong>
              <ul style={{ listStyleType: "disc", paddingLeft: "20px" }}>
                <li>

                  If network traffic is not too high, the router's CPU may not need
                  to work hard. This usually happens during off-peak hours or when
                  the network is not heavily used.
                </li>
                <li>
                  Solution: Monitor the performance of the device during peak
                  traffic hours to see if the CPU is fully utilized. Use traffic
                  simulation tools to test the performance of the device under
                </li>
              </ul>
              <div></div>
            </li>
            <li>
              <strong>
                Router Specifications Too High for Needs
              </strong>
              <ul style={{ listStyleType: "disc", paddingLeft: "20px" }}>
                <li>

                  A router with a powerful CPU for the current network needs can
                  cause underutilization, especially if only used for basic routing
                  without additional features.
                </li>
                <li>
                  Solution: Make sure the router specifications are suitable for
                  the network needs. If the router supports additional features
                  such as firewall or VPN, consider enabling these features to
                  increase CPU utilization.
                </li>
              </ul>
              <div></div>
            </li>
            <li>
              <strong>Less Optimal Configuration</strong>
              <ul style={{ listStyleType: "disc", paddingLeft: "20px" }}>
                <li>
                  Some configurations can cause traffic not to be evenly distributed
                  to all available CPU cores, resulting in low CPU utilization.

                </li>
                <li>
                  Solution: Check the load balancing or load distribution
                  configuration, especially if the router has a multi-core CPU.
                  Ensure that heavy tasks such as NAT or VPN are distributed
                  properly to all cores.
                </li>
              </ul>
              <div></div>
            </li>
            <li>
              <strong>Bottleneck on Other Components</strong>
              <ul style={{ listStyleType: "disc", paddingLeft: "20px" }}>
                <li>
                  Underutilized can also occur if there is a bottleneck or
                  obstruction in other components such as memory or network ports,
                  which limits overall performance even though the CPU is not
                  overloaded.
                </li>
                <li>
                  Solution: Check memory usage and network port capacity to ensure
                  there are no bottlenecks. If necessary, upgrade or adjust settings
                  so that all components can work optimally.
                </li>
              </ul>
              <div></div>
            </li>
            <li>
              <strong>Optimize Router Feature Usage</strong>
              <ul style={{ listStyleType: "disc", paddingLeft: "20px" }}>
                <li>
                  If the router has additional features (such as IDS/IPS, advanced
                  firewall, QoS), enabling these features can increase CPU usage.

                </li>
                <li>
                  Solution: Enable additional features as needed, such as packet
                  inspection, traffic control, or security features to maximize
                  router usage.
                </li>
              </ul>
              <div></div>
            </li>
          </ol>
        </div>
      )
    },
    memoryServer: {
      title: "Memory",
      definition: (
        <div>
          <ul style={{ listStyleType: "disc", paddingLeft: "20px" }}>
            <li>RAM (Random Access Memory) is temporary memory used by network devices to quickly store and access data.</li>
            <li>Memory nearing full capacity occurs when in a warning state (usage {'>'} 50%) and a critical state (usage {'>'} 80%), indicating that the device is approaching its capacity limit, which can disrupt or hinder its performance.</li>
          </ul>
        </div>
      ),
      analysis: (
        <div>
          <p>If the memory capacity is nearly full:</p>
          <ul style={{ listStyleType: "disc", paddingLeft: "20px" }}>
            <li><strong>Decreased Performance:</strong> Data processing becomes slower, affecting the device's responsiveness.</li>
            <li><strong>Service Disruption:</strong> Network services are hindered, causing delays or downtime.</li>
            <li><strong>Risk of Crash:</strong> Excessive memory usage can cause the device to become unstable or fail to operate.</li>
            <li><strong>Systemic Effects:</strong> Other devices in the network may be affected, worsening overall performance.</li>
          </ul>
          <br />
          
        </div>
      ),
      solution: (
        <div>
          <p>
            Do the following recommendations to solve the Memory Device problem:
          </p>
          <ol style={{ listStyleType: "decimal", paddingLeft: "20px" }}>

            <li> Increase the Memory capacity on the affected node.</li>
            <li>
              Identify and optimize applications that use a lot of Memory.
            </li>
            <li>Stop unnecessary applications to free up Memory.</li>
            <li>
              Use more efficient paging or swap techniques if possible.
            </li>
            <li>
              Distribute applications to other nodes with lower Memory usage.
            </li>
          </ol>
        </div>
      )
    },
    memoryUnderutilizedServer: {
      title: "Memory Underutilized",
      definition: (
        <div>
          <ul style={{ listStyleType: "disc", paddingLeft: "20px" }}>
            <li>RAM (Random Access Memory) is temporary memory used by network devices to quickly store and access data.</li>
            <li>Memory Underutilization occurs when memory usage is {'<'} 30%, indicating that the device is not being utilized optimally, resulting in wasted capacity.</li>
          </ul>
        </div>
      ),
      analysis: (
        <div>
          <p>If the memory capacity is underutilized:</p>
          <ul style={{ listStyleType: "disc", paddingLeft: "20px" }}>
            <li><strong>Low Efficiency:</strong> The device's capacity is not being used optimally.</li>
            <li><strong>Inefficient Power Consumption:</strong> The device remains active despite resources not being used effectively.</li>
            <li><strong>High Operational Costs:</strong> The device is not being used according to its actual needs.</li>
          </ul>
          <br />
          
        </div>
      ),
      solution: (
        <div>

          <p>
            Here are the steps you can take to address underutilized or underloaded
            RAM:
          </p>
          <ol style={{ listStyleType: "decimal", paddingLeft: "20px" }}>
            <li>

              <strong>Device Not Configured for Maximum Load</strong>

              <ul style={{ listStyleType: "disc", paddingLeft: "20px" }}>
                <li>
                  If the device only performs basic functions (such as simple
                  routing or NAT) without additional features such as firewall, QoS,
                  or VPN. RAM may not be used optimally.
                </li>
                <li>
                  Solution: Enable additional relevant features, such as packet
                  inspection (DPI), Quality of Service (QoS), or traffic logging.
                  Adjust the configuration to utilize features that support network
                  stability and security.
                </li>
              </ul>
              <div></div>
            </li>
            <li>
              <strong>⁠Device Specifications Too High for Needs</strong>
              <ul style={{ listStyleType: "disc", paddingLeft: "20px" }}>
                <li>
                  A router with large RAM may be designed to handle a much higher
                  network load than you currently have.
                </li>
                <li>
                  Solution: Evaluate network needs. If your network needs are small,
                  you may be able to use a device with lower specifications. However,
                  if there are plans to expand the network, no special action is
                  needed, as extra RAM will be beneficial in the future.

                </li>
              </ul>
              <div></div>
            </li>
            <li>
              <strong>⁠Light Network Traffic</strong>
              <ul style={{ listStyleType: "disc", paddingLeft: "20px" }}>
                <li>
                  If your network is not too busy or there are not many devices
                  connected, the device may not be able to use RAM to the maximum.

                </li>
                <li>
                  Solution: Test the device's performance under heavier traffic.
                  Simulate traffic using tools like iPerf or trafgen to see how
                  memory is used under heavy conditions.
                </li>
              </ul>
              <div></div>
            </li>
            <li>
              <strong>⁠Cache Not Utilized Optimally</strong>
              <ul style={{ listStyleType: "disc", paddingLeft: "20px" }}>
                <li>
                  Router RAM is often used for caching (such as ARP cache, DNS cache,
                  or buffering). If the cache is small, RAM is not optimally used.

                </li>
                <li>
                  Solution: Increase the size of the DNS, ARP, or packet buffer cache
                  if the device supports these settings. If you use features like
                  Content Filtering or Proxy, adjust them to use memory more
                  efficiently.
                </li>
              </ul>
              <div></div>
            </li>
            <li>
              <strong>Logging Not Enabled</strong>
              <ul style={{ listStyleType: "disc", paddingLeft: "20px" }}>
                <li>

                  Logging network activity uses RAM. If logging is turned off, RAM
                  will remain empty.
                </li>
                <li>
                  Solution: Enable logging on the router for network monitoring.
                  Save logs to local storage for analysis or troubleshooting in the
                  future. Note: Be careful not to make logs too large to overload
                </li>
              </ul>
              <div></div>
            </li>
            <li>
              <strong>⁠Potential Bottleneck on Other Components</strong>
              <ul style={{ listStyleType: "disc", paddingLeft: "20px" }}>
                <li>

                  If other components such as CPU or network port become a bottleneck,
                  the router cannot use RAM optimally.
                </li>
                <li>
                  Solution: Analyze the performance of the device as a whole. If the
                  CPU or port bandwidth is too low, consider upgrading the router or
                  optimizing the configuration.
                </li>
              </ul>
              <div></div>
            </li>
          </ol>
        </div>
      )
    },
    storageServer: {
      title: "Storage",
      definition: (
        <div>
          <ul style={{ listStyleType: "disc", paddingLeft: "20px" }}>
            <li>Storage is the capacity to store data on network devices, such as HDD or SSD, which hold data, configurations, and logs essential for the device's operation.</li>
            <li>Storage is almost full when it reaches a warning status (usage {'>'} 50%) and critical status (usage {'>'} 80%), indicating the device is approaching its capacity limit, which can affect its performance.</li>
          </ul>
        </div>
      ),
      analysis: (
        <div>
          <p>If storage capacity is almost full:</p>
          <ul style={{ listStyleType: "disc", paddingLeft: "20px" }}>
            <li><strong>Performance Degradation:</strong> Full storage can slow down data processing.</li>
            <li><strong>Operational Disruption:</strong> New data cannot be stored, causing system or application failure.</li>
            <li><strong>Potential Data Loss:</strong> The risk of losing important data increases as storage capacity is insufficient.</li>
          </ul>
          
        </div>
      ),
      solution: (
        <div>
          <p>
            Do the following recommendations to solve the Storage Device problem:
          </p>
          <ol style={{ listStyleType: "decimal", paddingLeft: "20px" }}>
            <li>Remove or archive unnecessary data to free up storage space.</li>
            <li>Optimize storage usage by compressing data if possible.</li>
            <li>Move rarely accessed data to slower or cheaper storage.</li>
            <li>Increase storage capacity by adding new drives or upgrading existing drives.</li>
            <li>Implement stricter data retention policies to limit the amount of data stored.</li>
          </ol>
        </div>
      )
    },
    storageUnderutilizedServer: {
      title: "Storage Underutilized",
      definition: (
        <div>
          <ul style={{ listStyleType: "disc", paddingLeft: "20px" }}>
            <li>Storage is the capacity to store data on network devices, such as HDD or SSD, which hold data, configurations, and logs essential for the device's operation.</li>
            <li>Storage underutilization occurs when storage usage is {'<'} 30%, indicating that the device is not being fully utilized, resulting in wasted capacity.</li>
          </ul>
        </div>
      ),
      analysis: (
        <div>
          <p>If storage is underutilized:</p>
          <ul style={{ listStyleType: "disc", paddingLeft: "20px" }}>
            <li><strong>Cost Inefficiency:</strong> Unused storage wastes costs without providing significant benefits.</li>
            <li><strong>Potential Overprovisioning:</strong> Excess capacity creates wasted resources.</li>
          </ul>
          <br />
          
        </div>
      ),
      solution: (
        <div>

          <p>
            Here are the steps you can take to address underutilized or underloaded
            Storage:
          </p>
          <ol style={{ listStyleType: "decimal", paddingLeft: "20px" }}>
            <li>
              <strong>Basic Router Function</strong>
              <ul style={{ listStyleType: "disc", paddingLeft: "20px" }}>
                <li>

                  Routers that are only used for basic routing and NAT usually do
                  not require much storage. Most of the storage space will be used
                  for the operating system, minimal logs, or configuration.

                </li>
                <li>

                  Solution: If the basic functions are sufficient, there is no need
                  to worry. However, you can consider additional features such as
                  detailed logging or caching to optimize your storage.
                </li>
              </ul>
              <div></div>
            </li>
            <li>
              <strong>Excessive Storage Capacity</strong>
              <ul style={{ listStyleType: "disc", paddingLeft: "20px" }}>
                <li>
                  Modern routers are often equipped with large storage to support
                  additional features such as logging, caching, or additional
                  applications. If these features are not activated, storage will
                  appear underutilized.
                </li>
                <li>
                  Solution: Evaluate whether there are features that can be
                  activated, such as traffic logging, DNS caching, or QoS
                  monitoring. Consider using storage for backup configuration files
                  or firmware.
                </li>
              </ul>
              <div></div>
            </li>
            <li>
              <strong>Logging Not Enabled</strong>
              <ul style={{ listStyleType: "disc", paddingLeft: "20px" }}>
                <li>
                  Routers use storage to store network activity logs, such as
                  traffic, security events, or system configuration. If logging is
                  turned off or directed to an external server, storage will be
                  empty.
                </li>
                <li>
                  Solution: Enable logging on the router for network monitoring.
                  Save logs to local storage for analysis or troubleshooting in the
                  future. Note: Be careful not to make logs too large so as not to
                  overload storage.

                </li>
              </ul>
              <div></div>
            </li>
            <li>
              <strong>Not Using Caching Features</strong>
              <ul style={{ listStyleType: "disc", paddingLeft: "20px" }}>
                <li>
                  Some routers support caching for DNS, ARP, or other data to
                  improve performance. If caching is turned off, storage will be
                  underutilized.
                </li>
                <li>
                  Solution: Enable caching features if the router supports it,
                  especially for networks with many DNS requests or repeated
                  traffic.
                </li>
              </ul>
              <div></div>
            </li>
            <li>
              <strong>No Use of Firmware or Extra Add-Ons</strong>
              <ul style={{ listStyleType: "disc", paddingLeft: "20px" }}>
                <li>

                  Some routers support the installation of additional applications
                  such as VPN servers, IDS/IPS, or monitoring. If additional
                  applications are not used, storage will be empty.

                </li>
                <li>
                  Solution: Install additional applications if possible and relevant
                  to your network needs. Update firmware regularly, and save several
                  backup versions in storage for rollback if problems occur.

                </li>
              </ul>
              <div></div>
            </li>
            <li>
              <strong>Backup or Configuration Capacity</strong>
              <ul style={{ listStyleType: "disc", paddingLeft: "20px" }}>
                <li>
                  Storage can be used to store configuration files, system backups,
                  or network automation scripts.
                </li>
                <li>
                  Solution: Store important configuration backups in router storage.
                  Create automation scripts for administrative tasks (if the router
                  supports scripting).
                </li>
              </ul>
              <div></div>
            </li>
            <li>
              <strong>Using Storage for File Sharing</strong>
              <ul style={{ listStyleType: "disc", paddingLeft: "20px" }}>
                <li>
                  Some routers with USB storage or network-attached storage (NAS)
                  features can be used to share files on the local network.

                </li>
                <li>

                  Solution: If your router supports this feature, use storage to share
                  documents, media, or important files on the network.
                </li>
              </ul>
              <div></div>
            </li>
          </ol>
        </div>
      )
    },
    webapi: {
      title: "Web API",
      definition: (
        <div>
          <ul style={{ listStyleType: "disc", paddingLeft: "20px" }}>
            <li>
              Response Time refers to the time required to receive a response from a server after a request is sent through an application programming interface (API) or website. It includes the duration from the moment the request is sent by the client (e.g., browser, application, or integration tool) until the response is received and processed.
            </li>
          </ul>
        </div>
      ),
      analysis: (
        <div>
          <p>Factors influencing Web/API Response Time include:</p>
          <ol style={{ listStyleType: "decimal", paddingLeft: "20px" }}>
            <li><strong>Server speed and performance:</strong> The server's capacity to handle requests.</li>
            <li><strong>Number of user requests:</strong> Traffic spikes can slow down responses.</li>
            <li><strong>Geographical distance:</strong> The farther the server is from the client, the higher the latency.</li>
            <li><strong>Code optimization:</strong> The structure and efficiency of backend or service code.</li>
            <li><strong>Network performance:</strong> Stability and speed of the internet connection.</li>
            <li><strong>Cache:</strong> Use of caching to reduce server processing load.</li>
          </ol>
          <br />
          <p>Impacts of high Web/API Response Time:</p>
          <ol style={{ listStyleType: "decimal", paddingLeft: "20px" }}>
            <li><strong>Reduced User Satisfaction:</strong> Users may feel frustrated if a webpage or API response takes too long.</li>
            <li><strong>Increased Bounce Rate:</strong> Slow websites or apps may cause users to leave before completing tasks.</li>
            <li><strong>Poor Reputation:</strong> Negative experiences can lead to bad reviews or word-of-mouth.</li>
            <li><strong>Customer Loss:</strong> Users may switch to competitors offering faster services.</li>
            <li><strong>Lower Conversion Rates:</strong> A one-second delay can reduce conversions by up to 7%.</li>
            <li><strong>Revenue Loss:</strong> Slow responses may reduce transactions and purchases.</li>
            <li><strong>Higher Operational Costs:</strong> Slow response times often require investigation, debugging, and optimization, which can be costly.</li>
            <li><strong>Increased Server Load:</strong> Long response times consume more server resources, like CPU and RAM.</li>
            <li><strong>System Congestion:</strong> Delayed requests may create queues, worsening overall performance.</li>
            <li><strong>Lower Search Engine Rankings:</strong> Google prioritizes faster-loading websites.</li>
            <li><strong>Reduced Crawl Rate:</strong> Search engine bots, like Googlebot, may visit slow sites less frequently.</li>
          </ol>
        </div>
      ),
      solution: (
        <div>
          <p>To address high response times, you can take the following steps:</p>
          <ol style={{ listStyleType: "decimal", paddingLeft: "20px" }}>
            <li>
              <strong>Backend Optimization</strong>
              <ul style={{ listStyleType: "disc", paddingLeft: "20px" }}>
                <li>
                  Efficient Database Queries:
                  <ul style={{ listStyleType: "circle", paddingLeft: "20px" }}>
                    <li>Use indexes on columns frequently used in searches.</li>
                    <li>Avoid repetitive queries; combine them where possible.</li>
                    <li>Optimize SQL queries for faster execution.</li>
                  </ul>
                </li>
                <li>
                  Caching:
                  <ul style={{ listStyleType: "circle", paddingLeft: "20px" }}>
                    <li>Implement caching to store frequently used query results using tools like Redis or Memcached.</li>
                    <li>Use server-side or API gateway caching for API responses.</li>
                  </ul>
                </li>
                <li>
                  Code Optimization:
                  <ul style={{ listStyleType: "circle", paddingLeft: "20px" }}>
                    <li>Reduce the complexity of algorithms used in processing.</li>
                    <li>Avoid heavy operations in API requests, such as loops or processing large datasets without batching.</li>
                  </ul>
                </li>
              </ul>
            </li>
            <li>
              <strong>Enhance Infrastructure</strong>
              <ul style={{ listStyleType: "disc", paddingLeft: "20px" }}>
                <li>
                  Load Balancing:
                  <ul style={{ listStyleType: "circle", paddingLeft: "20px" }}>
                    <li>Distribute traffic evenly across multiple servers using load balancers like Nginx, HAProxy, or AWS Elastic Load Balancing.</li>
                  </ul>
                </li>
                <li>
                  Upgraded Servers:
                  <ul style={{ listStyleType: "circle", paddingLeft: "20px" }}>
                    <li>Increase server capacity for CPU, RAM, or storage.</li>
                    <li>Use SSDs for faster storage compared to HDDs.</li>
                  </ul>
                </li>
                <li>
                  Horizontal Scaling:
                  <ul style={{ listStyleType: "circle", paddingLeft: "20px" }}>
                    <li>Add more servers to handle higher loads.</li>
                  </ul>
                </li>
                <li>
                  Use a Content Delivery Network (CDN):
                  <ul style={{ listStyleType: "circle", paddingLeft: "20px" }}>
                    <li>CDNs like Cloudflare or AWS CloudFront can speed up content delivery by distributing it from locations closer to users.</li>
                  </ul>
                </li>
              </ul>
            </li>
            <li>
              <strong>Reduce Network Latency</strong>
              <ul style={{ listStyleType: "disc", paddingLeft: "20px" }}>
                <li>
                  Optimize Server Locations:
                  <ul style={{ listStyleType: "circle", paddingLeft: "20px" }}>
                    <li>Choose data centers closer to your users.</li>
                    <li>If your user base is globally distributed, use regional servers or multi-cloud deployments.</li>
                  </ul>
                </li>
                <li>
                  Minimize Response Size:
                  <ul style={{ listStyleType: "circle", paddingLeft: "20px" }}>
                    <li>Compress data using Gzip or Brotli.</li>
                    <li>Use lightweight data formats like JSON or Protobuf, and avoid XML unless necessary.</li>
                  </ul>
                </li>
                <li>
                  Use HTTP/2:
                  <ul style={{ listStyleType: "circle", paddingLeft: "20px" }}>
                    <li>HTTP/2 enables faster parallel transfers than HTTP/1.1.</li>
                  </ul>
                </li>
              </ul>
            </li>
            <li>
              <strong>API Optimization</strong>
              <ul style={{ listStyleType: "disc", paddingLeft: "20px" }}>
                <li>
                  Pagination and Batching:
                  <ul style={{ listStyleType: "circle", paddingLeft: "20px" }}>
                    <li>For large datasets, use pagination or batching to split data into smaller chunks.</li>
                  </ul>
                </li>
                <li>
                  Specific Endpoints:
                  <ul style={{ listStyleType: "circle", paddingLeft: "20px" }}>
                    <li>Create API endpoints that return only the data required by the client.</li>
                    <li>Avoid returning excessive data.</li>
                  </ul>
                </li>
                <li>
                  Implement Rate Limiting:
                  <ul style={{ listStyleType: "circle", paddingLeft: "20px" }}>
                    <li>Limit the number of requests per client to prevent misuse or traffic spikes.</li>
                  </ul>
                </li>
              </ul>
            </li>
          </ol>
        </div>
      ),
    },
    deviceDown: {
      title: "Device Down",
      definition: (
        <div>
          <ul style={{ listStyleType: "disc", paddingLeft: "20px" }}>
            <li>
              Power refers to the electrical energy source that a device requires to operate. Devices need electricity to power internal components like processors, memory, antennas, and network ports.
            </li>
            <li>
              The network from the ISP (Internet Service Provider) is the infrastructure provided by the service provider to connect customers to the global internet.
            </li>
          </ul>
        </div>
      ),
      analysis: (
        <div>
          <p>Mona does not yet have enough data to analyze this case but suggests that such issues often arise due to Device Power Failure or ISP Network Downtime.</p>
          <p>Router power failure can lead to the following issues:</p>
          <ol style={{ listStyleType: "decimal", paddingLeft: "20px" }}>
            <li style={{ paddingLeft: "20px" }}>
              <strong>No Internet Access:</strong> All devices connected to the router, such as computers, smartphones, or IoT devices, cannot access the internet.
            </li>
            <li style={{ paddingLeft: "20px" }}>
              <strong>Access Point or Extender Down:</strong> If the router serves as a connector for other network devices (e.g., access points or repeaters), the entire network could be disrupted.
            </li>
            <li style={{ paddingLeft: "20px" }}>
              <strong>Local Server Disconnected:</strong> For businesses, a router failure may disconnect access to local servers or cloud-based services.
            </li>
            <li style={{ paddingLeft: "20px" }}>
              <strong>Smart Home Devices Inactive:</strong> Devices such as security cameras, smart speakers, smart lights, or smart locks connected to the router will stop functioning. Security cameras or sensors relying on an internet connection will be unable to monitor the environment.
            </li>
            <li style={{ paddingLeft: "20px" }}>
              <strong>Network Configuration Issues:</strong> A sudden router shutdown might require reconfiguring some network settings.
            </li>
            <li style={{ paddingLeft: "20px" }}>
              <strong>Potential Data Corruption:</strong> In some cases, a sudden shutdown during critical processes (e.g., firmware updates) can cause data corruption or device malfunction.
            </li>
          </ol>
          <p>ISP network downtime can cause the following issues:</p>
          <ol style={{ listStyleType: "decimal", paddingLeft: "20px" }}>
            <li style={{ paddingLeft: "20px" }}>
              <strong>No Internet Access:</strong> All devices connected to the ISP network, including smartphones, computers, and IoT devices, cannot access the internet.
            </li>
            <li style={{ paddingLeft: "20px" }}>
              <strong>Smart Home Devices Stop Functioning:</strong> Smart devices like thermostats, smart locks, or smart lights will lose functionality.
            </li>
            <li style={{ paddingLeft: "20px" }}>
              <strong>Cloud Services Unreachable:</strong> Users cannot access files, applications, or systems stored in the cloud.
            </li>
          </ol>
        </div>
      ),
      solution: (
        <div>
          <p>If the device power is off, you can take the following steps:</p>
          <ol style={{ listStyleType: "decimal", paddingLeft: "20px" }}>
            <li style={{ paddingLeft: "20px" }}>
              <strong>Check the Power Source:</strong>
              <ul style={{ listStyleType: "disc", paddingLeft: "20px" }}>
                <li>Ensure the router's power adapter is correctly plugged into the outlet and the router's power port.</li>
                <li>Test the outlet with another device to verify it is functioning correctly.</li>
                <li>If the adapter is damaged, try using another one that matches the router's specifications.</li>
              </ul>
            </li>
            <li style={{ paddingLeft: "20px" }}>
              <strong>Inspect the Router's Power Indicator:</strong>
              <ul style={{ listStyleType: "disc", paddingLeft: "20px" }}>
                <li>If no indicators light up, the problem likely lies in the power source or hardware.</li>
                <li>If the light blinks or dims, it may indicate unstable power. Use a stabilizer or UPS to ensure stable power flow.</li>
              </ul>
            </li>
            <li style={{ paddingLeft: "20px" }}>
              <strong>Reset the Router (If the Device Powers On Briefly):</strong>
              <ul style={{ listStyleType: "disc", paddingLeft: "20px" }}>
                <li>Turn off the router, unplug it, wait for about 5-10 minutes, then plug it back in and turn it on.</li>
                <li>If the router powers on but malfunctions, use the reset button to restore factory settings (note: this will erase all settings).</li>
              </ul>
            </li>
            <li style={{ paddingLeft: "20px" }}>
              <strong>Check the Router's Temperature and Cleanliness:</strong>
              <ul style={{ listStyleType: "disc", paddingLeft: "20px" }}>
                <li>Overheating may cause the router to shut down to protect its components. Ensure it has proper ventilation and is not placed in a closed space.</li>
                <li>Clean any dust accumulated on the ventilation holes using a soft cloth or compressed air.</li>
              </ul>
            </li>
            <li style={{ paddingLeft: "20px" }}>
              <strong>Inspect Router Hardware Components:</strong>
              <ul style={{ listStyleType: "disc", paddingLeft: "20px" }}>
                <li>Check if the router's power port is loose or damaged. If damaged, the router may need to be repaired by a technician.</li>
                <li>Inspect the power cable for physical damage such as tears or exposed wires.</li>
              </ul>
            </li>
            <li style={{ paddingLeft: "20px" }}>
              <strong>Visit a Service Center:</strong>
              <ul style={{ listStyleType: "disc", paddingLeft: "20px" }}>
                <li>If all the above steps fail, the issue may involve internal hardware damage, such as:</li>
                <ul style={{ listStyleType: "circle", paddingLeft: "20px" }}>
                  <li>Damaged capacitors or power ICs.</li>
                  <li>Short circuits in internal components.</li>
                </ul>
                <li>Take the router to an authorized service center or an experienced technician for repairs.</li>
              </ul>
            </li>
          </ol>
          <p>If the ISP network is down, you can take the following steps:</p>
          <ol style={{ listStyleType: "decimal", paddingLeft: "20px" }}>
            <li style={{ paddingLeft: "20px" }}>
              <strong>Check Connection Status:</strong>
              <ul style={{ listStyleType: "disc", paddingLeft: "20px" }}>
                <li>Inspect the router/modem indicator lights. The power, internet, and Wi-Fi lights provide information about the network status. A red or off internet light indicates an ISP issue.</li>
                <li>Connect a device directly to the modem (bypassing the router) using a LAN cable to confirm whether the issue lies with the router.</li>
              </ul>
            </li>
            <li style={{ paddingLeft: "20px" }}>
              <strong>Check for External Causes:</strong>
              <ul style={{ listStyleType: "disc", paddingLeft: "20px" }}>
                <li>Power outages in the ISP's area may affect the network.</li>
                <li>Heavy rain or storms could damage ISP infrastructure, such as cables or antennas.</li>
                <li>Contact your ISP's customer service to check for outages in your area.</li>
              </ul>
            </li>
            <li style={{ paddingLeft: "20px" }}>
              <strong>Restart Devices:</strong>
              <ul style={{ listStyleType: "disc", paddingLeft: "20px" }}>
                <li>Turn off devices for 1-2 minutes, then turn them back on.</li>
                <li>Ensure that connected devices like laptops or smartphones are updated and free from problematic network caches.</li>
              </ul>
            </li>
            <li style={{ paddingLeft: "20px" }}>
              <strong>Report the Issue to Your ISP:</strong>
              <ul style={{ listStyleType: "disc", paddingLeft: "20px" }}>
                <li>Contact your ISP's customer service and provide information about your location and the specific problem you're experiencing (e.g., indicator light issues, slow connection, or complete disconnection).</li>
                <li>Use the ISP's app or website to monitor outages and report issues.</li>
                <li>Find out the estimated repair time so you can plan alternatives, such as using a backup network from another ISP.</li>
              </ul>
            </li>
          </ol>
        </div>
      ),
    },
    online: (
      <div>
        <p> Online is a condition where the device is on and the internet can be accessed by the user.</p>
        <p> Do regular monitoring and activate notification features so that the service can run smoothly and preventive actions can be taken immediately in case of incidents to reduce internet downtime.</p>
      </div>
    ),
    dyingGasp: (
      <div>
        <p>
          Dying Gasp is the last signal sent by the ONT/modem before it dies. To
          solve this problem, do the following steps:
        </p>
        <ol>

          <li>Make sure the adapter is properly and tightly installed.</li>
          <li>Press the power button on the ONT/modem.</li>
          <li>Wait until the power, internet, and wifi lights on the ONT are on.</li>
          <li>
            Connect:
            <ul>
              <li>

                If using LAN: make sure the LAN cable is properly and tightly
                installed on the LAN3 ONT port.
              </li>
              <li>
                If using Wifi: if the wifi ONT light is off, press the wifi button
                until it lights up.
              </li>
            </ul>
          </li>
        </ol>
      </div>
    ),
    los: (
      <div>
        <p>
          Loss of Signal (LOS) occurs when the modem loses its signal. This can happen due to fiber issues or cable problems.
        </p>
        <p>
          Solutions for Internet LOS status:
          <br />
          <br />
          You can try the following steps:
        </p>
        <ul>
          <li>Turn off the modem, wait for a moment, then turn it back on</li>
          <li>
            Check all cables to ensure they are properly connected (make sure the optical cable is securely plugged into the modem with a "click" sound).
          </li>
          <li>Ensure the modem is powered on</li>
          <li>
            Perform a modem reset (IMPORTANT: This will erase the modem's configuration and settings. Ensure you have a backup of this information before resetting).
          </li>
        </ul>
      </div>
    ),
    offline: (
      <div>
        <p>Offline occurs when the user turns off the internet modem.</p>
        <p>
          Solutions for Internet Offline status:
          <br />
          <br />
          You can try:
        </p>
        <ul>
          <li>Turn on the modem</li>
          <li>Restart the modem</li>
        </ul>
      </div>
    ),
    sync: (
      <div>
        <p>Sync indicates the internet is in the process of synchronization.</p>
      </div>
    ),
    unknown: (
      <div>
        <p>
          Unknown indicates that the internet is experiencing technical issues, making measurement data unavailable.
        </p>
      </div>
    ),
    suspend: (
      <div>
        <p>
          Please complete the payment for your suspended device so you can resume monitoring it.
        </p>
      </div>
    ),
    test: (
      <div style={{ listStyleType: "disc", paddingLeft: "20px" }}>test</div>
    ),
  };


  return (
    <div style={{ width: "100%", padding: "0.5rem 0rem", margin: "0 auto" }}>
      <h2 style={{ fontWeight: "bold", marginBottom: "10px" }}>{t("prime.detailAnalysis.solution")}</h2>
      {loginType === "hi" ?
        <>
          {rootCause
            .filter((el) => validTitles.includes(el))
            .map((item) => (
              <div key={item} style={{ marginBottom: "10px" }}>
                {/* Button to toggle the recommendation visibility */}
                <button
                  onClick={() => toggleRecommendation(item)}
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    padding: "0.5rem",
                    backgroundColor: Colors.primary50,
                    border: "none",
                    borderRadius: "5px",
                    cursor: "pointer",
                    width: "100%",
                  }}
                >
                  <span style={{ fontSize: "15px", fontWeight: 600 }}>
                    {formatRecommendationTitle(item, i18n.language)}
                  </span>
                  {visibleRecommendations[item] ? <ArrowUp color={Colors.neutral90}/> : <ArrowDown color={Colors.neutral90}/>}
                </button>

                {/* Recommendation content */}
                {visibleRecommendations[item] && (
                  <div
                    style={{
                      padding: "10px",
                      backgroundColor: "#f0f0f0",
                      borderRadius: "5px",
                      marginTop: "5px",
                    }}
                  >
                    <div style={tagsStyles}>
                      {i18n.language === 'id' ? recommendations[item] : englishRecommendations[item]}
                    </div>
                  </div>
                )}
              </div>
            ))}
        </> :
        <>
          {rootCause
            .filter((el) => {
              // Check if the object has a non-empty array (solution)
              return Object.values(el).some((value) => value.length > 0);
            })
            .map((item, index) => {
              const rootCauseKey = Object.keys(item)[0]; // Get the key like 'cpu', 'cpuUnderutilized', etc.
              const rootCauseValue = item[rootCauseKey]; // Get the array of values (e.g., ["Routing Engine-1-0-0", ...])

              return (
                <div key={index} style={{ marginBottom: "10px" }}>
                  {/* Button to toggle the recommendation visibility */}
                  <button
                    onClick={() => toggleRecommendation(rootCauseKey)}
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "space-between",
                      padding: "0.5rem",
                      backgroundColor: Colors.primary20,
                      border: "none",
                      borderRadius: visibleRecommendations[rootCauseKey] ? "5px 5px 0 0" : "5px",
                      cursor: "pointer",
                      width: "100%",
                    }}
                  >
                    <span style={{ fontSize: "15px", fontWeight: 600 }}>
                      {formatRecommendationTitle(rootCauseKey, i18n.language)}
                    </span>
                    {visibleRecommendations[rootCauseKey] ? <ArrowUp color={Colors.neutral90}/> : <ArrowDown color={Colors.neutral90}/>}
                  </button>

                  {/* Recommendation content */}
                  {visibleRecommendations[rootCauseKey] && (

                    <div
                      style={{
                        padding: "10px",
                        backgroundColor: Colors.neutral2,
                        borderRadius: "0 0 5px 5px",
                        marginTop: "5px",
                      }}
                    >
                      <p style={{ fontSize: "14px", fontWeight: 500, marginBottom: '1rem' }}>
                         {rootCauseValue.join("")}
                      </p>




                      {["definition", "analysis", "solution"].map((section) => (
                        <div key={section} style={{ marginBottom: "10px" }}>
                          {/* Button to toggle each section */}
                          <button
                            onClick={() =>
                              setVisibleSections((prev) => ({
                                ...prev,
                                [`${rootCauseKey}_${section}`]: !prev[`${rootCauseKey}_${section}`],
                              }))
                            }
                            style={{
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "space-between",
                              padding: "0.5rem",
                              backgroundColor: Colors.neutral10,
                              border: "none",
                              borderRadius: visibleSections[`${rootCauseKey}_${section}`] ? "5px 5px 0 0" : "5px",
                              cursor: "pointer",
                              width: "100%",
                            }}
                          >
                            <span style={{ fontSize: "14px", fontWeight: 500 }}>
                              {section.charAt(0).toUpperCase() + section.slice(1)}
                            </span>
                            {visibleSections[`${rootCauseKey}_${section}`] ? 
                            <ArrowUp color={Colors.neutral90}/> : <ArrowDown color={Colors.neutral90}/>}
                          </button>

                          {/* Section content */}
                          {visibleSections[`${rootCauseKey}_${section}`] && (
                            <div
                              style={{
                                padding: "10px",
                                backgroundColor: Colors.white,
                                borderRadius: "0 0 5px 5px",
                                marginTop: "5px",
                              }}
                            >
                              <div style={tagsStyles}>
                                {
                                  i18n.language === "id"
                                    ? recommendations[
                                      rootCauseKey === "processCPU" || rootCauseKey === "containerCPU" ? "cpuServer" : rootCauseKey === "processMemory" || rootCauseKey === "containerCPU" ? "memoryServer" : rootCauseKey 
                                    ][section]
                                    : englishRecommendations[
                                      rootCauseKey === "processCPU" || rootCauseKey === "containerCPU" ? "cpuServer" : rootCauseKey === "processMemory" || rootCauseKey === "containerCPU" ? "memoryServer" : rootCauseKey
                                    ][section]
                                }
                              </div>
                            </div>
                          )}
                        </div>
                      ))}
                    </div>
                  )}
                </div>
              );
            })}
        </>}
    </div>
  );
};

export default Recommendations;
